import React, { useRef, useEffect, useState } from 'react'
import { ReactComponent as MySVG7 } from '../../../../../assets/brandokuma/symbol/MAN.svg'
import { ReactComponent as MySVG8 } from '../../../../../assets/brandokuma/symbol/GLOBAL.svg'
import { ReactComponent as MySVG9 } from '../../../../../assets/brandokuma/symbol/DENIMWEAR.svg'
import { ReactComponent as MySVG10 } from '../../../../../assets/brandokuma/symbol/WOMANBASICKARE.svg'
import { ReactComponent as MySVG11 } from '../../../../../assets/brandokuma/symbol/WOMANBASICCIRCLE.svg'
import { ReactComponent as MySVG12 } from '../../../../../assets/brandokuma/symbol/WOMANBASICTRIANGLE.svg'
import { ReactComponent as MySVG13 } from '../../../../../assets/brandokuma/symbol/KIDSBABYBOY.svg'
import { ReactComponent as MySVG14 } from '../../../../../assets/brandokuma/symbol/KIDSBABYGIRL.svg'
import { ReactComponent as MySVG15 } from '../../../../../assets/brandokuma/symbol/KIDSBOYKARE.svg'
import { ReactComponent as MySVG16 } from '../../../../../assets/brandokuma/symbol/KIDSGIRLDAIRE.svg'
import { ReactComponent as MySVG17 } from '../../../../../assets/brandokuma/symbol/KIDSBABYUNIT.svg'
import { ReactComponent as MySVG18 } from '../../../../../assets/brandokuma/symbol/LINGERIE.svg'



const renderShape = (currentShape, category, strokeColor = "#b2b5b4", width) => {
  const isFill =
    currentShape === 'WOMAN' ||
    currentShape === 'BASIC' ||
    currentShape === 'LINGERIE' ||
    currentShape === 'PREMIUM DENIM' ||
    currentShape === 'MAN' ||
    currentShape === 'TRF' ||
    currentShape === 'GIRL' ||
    currentShape === 'BOY';

  const commonStyle = isFill ? { fill: strokeColor } : { stroke: strokeColor };

  const defaultWidths = {
    WOMAN: '3.892mm',
    LINGERIE: '4.4mm',
    'PREMIUM DENIM': '3.852mm',
    BASIC: '3.852mm',
    TRF: '4.237mm',
    DENIMWEAR: '4.083mm',
    MAN: '3.852mm',
    GLOBAL: '3.852mm',
    GIRL: '3.852mm',
    'KIDS A (BABY GIRL)': '3.852mm',
    'BABY UNIQUE': '4.622mm',
    KNIT: '4.622mm',
    DENIM: '4.622mm',
    OUTERWEAR: '4.622mm',
    BOY: '3.852mm',
    'KIDS O (BABY BOY)': '3.852mm'
  };

  const appliedWidth = width ? `${width}mm` : defaultWidths[currentShape];

  if (category === 'Woman') {
    switch (currentShape) {
      case 'WOMAN':
        return <MySVG11 data-testid="svg-woman" style={{ width: appliedWidth, height: "auto", ...commonStyle }} />;

      case 'LINGERIE':
        return <MySVG18 data-testid="svg-lingerie" style={{ width: appliedWidth, height: "auto", ...commonStyle }} />;

      case 'PREMIUM DENIM':
        return <MySVG11 data-testid="svg-premium-denim" style={{ width: appliedWidth, height: "auto", ...commonStyle }} />;

      case 'BASIC':
        return <MySVG10 data-testid="svg-basic" style={{ width: appliedWidth, height: "auto", ...commonStyle }} />;

      case 'TRF':
        return <MySVG12 data-testid="svg-trf" style={{ width: appliedWidth, height: "auto", ...commonStyle }} />;

      default:
        return <></>;
    }
  } else if (category === 'Man') {
    switch (currentShape) {
      case 'DENIMWEAR':
        return <MySVG9 data-testid="svg-denimwear" style={{ width: appliedWidth, height: "auto", ...commonStyle }} />;

      case 'MAN':
        return <MySVG7 data-testid="svg-man" style={{ width: appliedWidth, height: "auto", ...commonStyle }} />;

      case 'GLOBAL':
        return <MySVG8 data-testid="svg-global" style={{ width: appliedWidth, height: "auto", ...commonStyle }} />;

      default:
        return <></>;
    }
  } else if (category === 'Kids') {
    switch (currentShape) {
      case 'GIRL':
        return <MySVG16 data-testid="svg-girl" style={{ width: appliedWidth, height: "auto", ...commonStyle }} />;

      case 'KIDS A (BABY GIRL)':
        return <MySVG14 data-testid="svg-kids-a" style={{ width: appliedWidth, height: "auto", ...commonStyle }} />;

      case 'BABY UNIQUE':
      case 'KNIT':
      case 'DENIM':
      case 'OUTERWEAR':
        return <MySVG17 data-testid="svg-baby-unique" style={{ width: appliedWidth, height: "auto", ...commonStyle }} />;

      case 'BOY':
        return <MySVG15 data-testid="svg-boy" style={{ width: appliedWidth, height: "auto", ...commonStyle }} />;

      case 'KIDS O (BABY BOY)':
        return <MySVG13 data-testid="svg-kids-o" style={{ width: appliedWidth, height: "auto", ...commonStyle }} />;

      default:
        return <></>;
    }
  } else {
    return <></>;
  }
};


// Referans adlarıyla bileşenleri tanımlıyoruz
const LABEL7HOMEWEAR70x10 = ({currentShape, category, referance, CountryName, filteredIndo, inx, szrgrp, valueBasedOnInx,CardBackBack}) => {
  const [TopValue, setTopValue] = useState("27px")

  // Gelen değerleri konsolda görmek için:
  console.log("USA Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.usa);
  console.log("EUR Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.europe);
  const usaValue = szrgrp?.sizes?.[valueBasedOnInx]?.usa;
  const eurValue =szrgrp?.sizes?.[valueBasedOnInx]?.europe;
  const mexValue =szrgrp?.sizes?.[valueBasedOnInx]?.mexico;

  console.log("refrefgeldi",referance)


  useEffect(() => {
    if (
      referance?.linecount === inx || // linecount, inx'e eşitse
      referance?.linecount === 0 || // linecount 0 ise
      (referance?.linecount !== 0 && inx % referance?.linecount === 0) // linecount 0 değilse ve inx'in katıysa
    ) {
      setTopValue("27.1px");
    } else {
      setTopValue("27px");

    }
  }, [referance, inx]); // 👈 Bağımlılıklar (referance veya inx değiştiğinde çalışır)
  return (
    <div style={{ position:"relative", width:"100%", minHeight:`${referance.height+2.5}mm` }}>
       {CardBackBack ? (
    <div 
      style={{
        position: "absolute", 
        top: `0`, // Her öğe için 5% fark ekleyerek aşağı kaydırıyoruz
    left: "0",

      }}
    >
      {(() => {
        const referenceCode = referance?.code;
        const referenceWidth = referance?.width;
        let width = `${referenceWidth}mm`;
        let height = "auto";

        return typeof CardBackBack === "function" ? (
          <CardBackBack width={width} height={height} />
        ) : (
          <img src={CardBackBack} alt="SVG Image" style={{ width, height }} />
        );
      })()}
    </div>
  ) : (
    <span>Loading...</span>
  )}
      <div style={{ position:"absolute", right:"8.83px", top:"20.05px" }}>
        {renderShape(currentShape, category,"#7c7d7f")}
      </div>

      {/* Şart: USA ile EUR eşitse bu bloğu döndür */}
      
      {usaValue === eurValue && category !== "Kids" && (
  <div
    style={{
      border: "1px solid transparent",
      position: "absolute",
      left: 2.5,
      top: "32.2px",
      width: "76.05%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 2,

    }}
  >
    <span
      className="zara-regular"
      style={{
        color: "black",
        fontSize: "3.69pt",

        display: "flex",
        alignItems: "center",
        gap: "3.7px", // Elemanlar arasında küçük boşluk
      }}
    >
      <span style={{ letterSpacing: -0.25,marginRight:7.2,fontSize:"3.9pt",wordSpacing:"0.7px" }}>
        MADE IN {CountryName}
      </span>

<div style={{ display: "flex", gap: "3px", alignItems: "center" }}>
  <div style={{ display: "flex", alignItems: "center", gap: "0.3px" }}>
    <span style={{ letterSpacing: "0",marginRight:0.3 }}>EUR</span>
    <span style={{ fontWeight: 900 }}>{eurValue}</span>
  </div>

  <div style={{ display: "flex", alignItems: "center", gap: "0.4px" }}>
    <span style={{ letterSpacing: "0",marginRight:0.3 }}>USA</span>
    <span style={{ fontWeight: 900 }}>{usaValue}</span>
  </div>

  <div style={{ display: "flex", alignItems: "center", gap: "0.4px" }}>
    <span style={{ letterSpacing: "0",marginRight:0.3 }}>MEX</span>
    <span style={{ fontWeight: 900 }}>{mexValue}</span>
  </div>
</div>

    </span>
  </div>
)}

      {usaValue !== eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top:"16.2px", width:"87.05%", display:"flex", justifyContent:"flex-end",zIndex:2,alignItems:"center"}}>
        <span
               className='HelveticaNeueLT57Condensed'
    style={{
      color: "#B1B4B3",
      fontSize: "8px",
      // İsterseniz letterSpacing veya wordSpacing'i buradan da verebilirsiniz
      // letterSpacing: 0.48,
      // wordSpacing: "2px",
    }}
  >
    {/* EUR */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        // marginTop: .1 --> inline-block'ta biraz yukarı boşluk yaratabilir
      }}
    >
      EUR
    </span>

    {/* EUR Value */}
    <span
      className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      {eurValue}
    </span>

    {/* USA */}
    <span
    
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      USA
    </span>

    {/* USA Value (Bold) */}
    <span

    className='HelveticaNeueLT77BoldCondensed'
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        fontWeight: 600,
      }}
    >
      {usaValue}
    </span>

    {/* MEX */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      MEX
    </span>

    {/* MEX Value (Bold, different letterSpacing) */}
    <span
        className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.8,
        fontWeight: 600,
      }}
    >
      {mexValue}
    </span>
  </span>
        </div>
      )}
      {category === "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top:"16.2px", width:"87.05%", display:"flex", justifyContent:"flex-end",zIndex:2 }}>
        <span
               className='HelveticaNeueLT57Condensed'
  style={{
    color: "#B1B4B3",
    fontSize: "8px",
    // Tek bir yerde letterSpacing ya da wordSpacing verebilirsiniz
    // letterSpacing: 0.48,
  }}
>
  {/* filteredIndo[inx]?.name */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      marginTop: 0.1, 
    }}
  >
    {filteredIndo[inx]?.name}
  </span>

  {/* 'MONTH' / 'YEARS' */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    {filteredIndo[inx]?.isMonth}
  </span>

  {/* filteredIndo[inx]?.cm?.slice(0, 3) */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      marginTop: 0.1, 
    }}
  >
    {filteredIndo[inx]?.cm?.slice(0, 3)}
  </span>

  {/* "CM" */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    CM
  </span>
</span>
        </div>
      )}
      
      {/* MADE IN Kısmı */}
    
    </div>
  );
};


const LABEL7DELTAWSIZE110x15 = ({currentShape, category, referance, CountryName, filteredIndo, inx, szrgrp, valueBasedOnInx,CardBackBack}) => {
  const [TopValue, setTopValue] = useState("27px")

  // Gelen değerleri konsolda görmek için:
  console.log("USA Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.usa);
  console.log("EUR Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.europe);
  const usaValue = szrgrp?.sizes?.[valueBasedOnInx]?.usa;
  const eurValue =szrgrp?.sizes?.[valueBasedOnInx]?.europe;
  const mexValue =szrgrp?.sizes?.[valueBasedOnInx]?.mexico;

  console.log("refrefgeldi",referance)


  useEffect(() => {
    if (
      referance?.linecount === inx || // linecount, inx'e eşitse
      referance?.linecount === 0 || // linecount 0 ise
      (referance?.linecount !== 0 && inx % referance?.linecount === 0) // linecount 0 değilse ve inx'in katıysa
    ) {
      setTopValue("27.1px");
    } else {
      setTopValue("27px");

    }
  }, [referance, inx]); // 👈 Bağımlılıklar (referance veya inx değiştiğinde çalışır)
  return (
    <div style={{ position:"relative", width:"100%", minHeight:`${referance.height+2.5}mm` }}>
       {CardBackBack ? (
    <div 
      style={{
        position: "absolute", 
        top: `0`, // Her öğe için 5% fark ekleyerek aşağı kaydırıyoruz
    left: "0",

      }}
    >
      {(() => {
        const referenceCode = referance?.code;
        const referenceWidth = referance?.width;
        let width = `${referenceWidth}mm`;
        let height = "auto";

        return typeof CardBackBack === "function" ? (
          <CardBackBack width={width} height={height} />
        ) : (
          <img src={CardBackBack} alt="SVG Image" style={{ width, height }} />
        );
      })()}
    </div>
  ) : (
    <span>Loading...</span>
  )}
      <div style={{ position:"absolute", right:"8.83px", top:"20.05px" }}>
        {renderShape(currentShape, category,"#7c7d7f")}
      </div>

      {/* Şart: USA ile EUR eşitse bu bloğu döndür */}
      
      {usaValue === eurValue && category !== "Kids" && (
  <div
    style={{
      border: "1px solid transparent",
      position: "absolute",
      left: -3,
      top: "44.6px",
      width: "417px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 2,

    }}
  >
    <span
      className="zara-regular"
      style={{
        color: "black",
        fontSize: "5pt",

        display: "flex",
        alignItems: "center",
        gap: "3.7px", // Elemanlar arasında küçük boşluk
      }}
    >
      <span style={{ letterSpacing: -0.25,marginRight:10.5,fontSize:"5.2pt",wordSpacing:"0.7px" }}>
        MADE IN {CountryName}
      </span>

<div style={{ display: "flex", gap: "3px", alignItems: "center" }}>
  <div style={{ display: "flex", alignItems: "center", gap: "0.3px" }}>
    <span style={{ letterSpacing: "0",marginRight:0.8 }}>EUR</span>
    <span style={{ fontWeight: 900 }}>{eurValue}</span>
  </div>

  <div style={{ display: "flex", alignItems: "center", gap: "0.4px" }}>
    <span style={{ letterSpacing: "0",marginRight:0.8 }}>USA</span>
    <span style={{ fontWeight: 900 }}>{usaValue}</span>
  </div>

  <div style={{ display: "flex", alignItems: "center", gap: "0.4px" }}>
    <span style={{ letterSpacing: "0",marginRight:0.8 }}>MEX</span>
    <span style={{ fontWeight: 900 }}>{mexValue}</span>
  </div>
</div>

    </span>
  </div>
)}

      {usaValue !== eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top:"16.2px", width:"87.05%", display:"flex", justifyContent:"flex-end",zIndex:2,alignItems:"center"}}>
        <span
               className='HelveticaNeueLT57Condensed'
    style={{
      color: "#B1B4B3",
      fontSize: "8px",
      // İsterseniz letterSpacing veya wordSpacing'i buradan da verebilirsiniz
      // letterSpacing: 0.48,
      // wordSpacing: "2px",
    }}
  >
    {/* EUR */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        // marginTop: .1 --> inline-block'ta biraz yukarı boşluk yaratabilir
      }}
    >
      EUR
    </span>

    {/* EUR Value */}
    <span
      className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      {eurValue}
    </span>

    {/* USA */}
    <span
    
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      USA
    </span>

    {/* USA Value (Bold) */}
    <span

    className='HelveticaNeueLT77BoldCondensed'
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        fontWeight: 600,
      }}
    >
      {usaValue}
    </span>

    {/* MEX */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      MEX
    </span>

    {/* MEX Value (Bold, different letterSpacing) */}
    <span
        className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.8,
        fontWeight: 600,
      }}
    >
      {mexValue}
    </span>
  </span>
        </div>
      )}
      {category === "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top:"16.2px", width:"87.05%", display:"flex", justifyContent:"flex-end",zIndex:2 }}>
        <span
               className='HelveticaNeueLT57Condensed'
  style={{
    color: "#B1B4B3",
    fontSize: "8px",
    // Tek bir yerde letterSpacing ya da wordSpacing verebilirsiniz
    // letterSpacing: 0.48,
  }}
>
  {/* filteredIndo[inx]?.name */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      marginTop: 0.1, 
    }}
  >
    {filteredIndo[inx]?.name}
  </span>

  {/* 'MONTH' / 'YEARS' */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    {filteredIndo[inx]?.isMonth}
  </span>

  {/* filteredIndo[inx]?.cm?.slice(0, 3) */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      marginTop: 0.1, 
    }}
  >
    {filteredIndo[inx]?.cm?.slice(0, 3)}
  </span>

  {/* "CM" */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    CM
  </span>
</span>
        </div>
      )}
      
      {/* MADE IN Kısmı */}
    
    </div>
  );
};


const WLZCALL029 = ({currentShape, category, referance, CountryName, filteredIndo, inx, szrgrp, valueBasedOnInx,CardBackBack}) => {
  const [TopValue, setTopValue] = useState("27px")

  // Gelen değerleri konsolda görmek için:
  console.log("USA Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.usa);
  console.log("EUR Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.europe);
  const usaValue = szrgrp?.sizes?.[valueBasedOnInx]?.usa;
  const eurValue =szrgrp?.sizes?.[valueBasedOnInx]?.europe;
  const mexValue =szrgrp?.sizes?.[valueBasedOnInx]?.mexico;
  console.log("refrefgeldi",referance)

  useEffect(() => {
    if (
      referance?.linecount === inx || // linecount, inx'e eşitse
      referance?.linecount === 0 || // linecount 0 ise
      (referance?.linecount !== 0 && inx % referance?.linecount === 0) // linecount 0 değilse ve inx'in katıysa
    ) {
      setTopValue("27.1px");
    } else {
      setTopValue("27px");

    }
  }, [referance, inx]); // 👈 Bağımlılıklar (referance veya inx değiştiğinde çalışır)
  return (
    <div style={{ position:"relative", width:"100%", minHeight:`${referance.height+2.5}mm` }}>
       {CardBackBack ? (
    <div 
      style={{
        position: "absolute", 
        top: `0`, // Her öğe için 5% fark ekleyerek aşağı kaydırıyoruz
    left: "0",

      }}
    >
      {(() => {
        const referenceCode = referance?.code;
        const referenceWidth = referance?.width;
        let width = `${referenceWidth}mm`;
        let height = "auto";

        return typeof CardBackBack === "function" ? (
          <CardBackBack width={width} height={height} />
        ) : (
          <img src={CardBackBack} alt="SVG Image" style={{ width, height }} />
        );
      })()}
    </div>
  ) : (
    <span>Loading...</span>
  )}
      <div style={{ position:"absolute", right:"32.83px", top:"31.05px" }}>
        {renderShape(currentShape, category,"#7c7d7f")}
      </div>

      {/* Şart: USA ile EUR eşitse bu bloğu döndür */}
      
      {usaValue === eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top: "33.2%", width:"78.9%", display:"flex", justifyContent:"flex-end",zIndex:2 }}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#B1B4B3",
    fontSize: "8px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text
  }}
>
  <span style={{ letterSpacing: "0.3px",
 }}>EUR</span>
  
  <span style={{ margin: "0 0.4px" ,   
}}>/</span>

  <span style={{ letterSpacing: "0.3px", 
 }}>USA</span>

  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    marginLeft: "2.9px",
    fontSize: "8.5px",        // Keep consistent base font size

  }}>
    {usaValue}
  </span>

  <span style={{
    marginLeft: "5.6px",
    letterSpacing: "0.4px",

  }}>
    MEX
  </span>

  <span 
  
  className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    letterSpacing: "0.8px",
    marginLeft: "2.5px",
    fontSize: "8.5px",        // Keep consistent base font size


  }}>
    {mexValue}
  </span>
</span>

        </div>
      )}
      {usaValue !== eurValue && category !== "Kids" && (
        <div
               className='HelveticaNeueLT57Condensed'

  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 0,
    top: "33.2%",
    width: "78.9%",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    zIndex: 2,
  }}
>
  {/* Tek bir ebeveyn span */}
  <span
               className='HelveticaNeueLT57Condensed'
    style={{
      color: "#B1B4B3",
      fontSize: "8px",
      // İsterseniz letterSpacing veya wordSpacing'i buradan da verebilirsiniz
      // letterSpacing: 0.48,
      // wordSpacing: "2px",
    }}
  >
    {/* EUR */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        // marginTop: .1 --> inline-block'ta biraz yukarı boşluk yaratabilir
      }}
    >
      EUR
    </span>

    {/* EUR Value */}
    <span
      className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      {eurValue}
    </span>

    {/* USA */}
    <span
    
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      USA
    </span>

    {/* USA Value (Bold) */}
    <span

    className='HelveticaNeueLT77BoldCondensed'
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        fontWeight: 600,
      }}
    >
      {usaValue}
    </span>

    {/* MEX */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      MEX
    </span>

    {/* MEX Value (Bold, different letterSpacing) */}
    <span
        className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.8,
        fontWeight: 600,
      }}
    >
      {mexValue}
    </span>
  </span>
</div>

      )}
      {category === "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top: "33.2%", width:"78.9%", display:"flex", justifyContent:"flex-end",zIndex:2 }}>
        <span
               className='HelveticaNeueLT57Condensed'
  style={{
    color: "#B1B4B3",
    fontSize: "8px",
    // Tek bir yerde letterSpacing ya da wordSpacing verebilirsiniz
    // letterSpacing: 0.48,
  }}
>
  {/* filteredIndo[inx]?.name */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
    }}
  >
    {filteredIndo[inx]?.name}
  </span>

  {/* 'MONTH' / 'YEARS' */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    {filteredIndo[inx]?.isMonth}
  </span>

  {/* filteredIndo[inx]?.cm?.slice(0, 3) */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
    }}
  >
    {filteredIndo[inx]?.cm?.slice(0, 3)}
  </span>

  {/* "CM" */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    CM
  </span>
</span>

        </div>
      )}
      
      {/* MADE IN Kısmı */}
      <div

  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 0,
    top: "37.1px",
    width: "78.87%",
    display: "flex",
    justifyContent: "flex-end",
    zIndex:2,
    transform: "translateY(0.5px)" 

  }}
>        <span  className='HelveticaNeueLT57Condensed' style={{ color:"#B1B4B3", fontSize:"8px", letterSpacing:0.43 }}>
          MADE IN {CountryName}
        </span>
      </div>
    </div>
  );
};


const WLZCALL030 = ({currentShape, category, referance, CountryName, filteredIndo, inx, szrgrp, valueBasedOnInx,CardBackBack}) => {
  const [TopValue, setTopValue] = useState("27px")

  // Gelen değerleri konsolda görmek için:
  console.log("USA Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.usa);
  console.log("EUR Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.europe);
  const usaValue = szrgrp?.sizes?.[valueBasedOnInx]?.usa;
  const eurValue =szrgrp?.sizes?.[valueBasedOnInx]?.europe;
  const mexValue =szrgrp?.sizes?.[valueBasedOnInx]?.mexico;
  console.log("refrefgeldi",referance)

  useEffect(() => {
    if (
      referance?.linecount === inx || // linecount, inx'e eşitse
      referance?.linecount === 0 || // linecount 0 ise
      (referance?.linecount !== 0 && inx % referance?.linecount === 0) // linecount 0 değilse ve inx'in katıysa
    ) {
      setTopValue("27.1px");
    } else {
      setTopValue("27px");

    }
  }, [referance, inx]); // 👈 Bağımlılıklar (referance veya inx değiştiğinde çalışır)
  return (
    <div style={{ position:"relative", width:"100%", minHeight:`${referance.height}mm` }}>
       {CardBackBack ? (
    <div 
      style={{
        position: "absolute", 
        top: `0`, // Her öğe için 5% fark ekleyerek aşağı kaydırıyoruz
    left: "0",

      }}
    >
      {(() => {
        const referenceCode = referance?.code;
        const referenceWidth = referance?.width;
        let width = `${referenceWidth}mm`;
        let height = "auto";

        return typeof CardBackBack === "function" ? (
          <CardBackBack width={width} height={height} />
        ) : (
          <img src={CardBackBack} alt="SVG Image" style={{ width, height }} />
        );
      })()}
    </div>
  ) : (
    <span>Loading...</span>
  )}
      <div style={{ position:"absolute", right:"12.83px", top:"22.05px" }}>
        {renderShape(currentShape, category,"#7c7d7f")}
      </div>

      {/* Şart: USA ile EUR eşitse bu bloğu döndür */}
      
      {usaValue === eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top: "48.4%", width:"84.7%", display:"flex", justifyContent:"flex-end",zIndex:2,    transform: "translateX(0.4px)" 
 }}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#7d7d7f",
    fontSize: "8px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text
  }}
>
  <span style={{ letterSpacing: "0.3px",
 }}>EUR</span>
  
  <span style={{ margin: "0 0.4px" ,   
}}>/</span>

  <span style={{ letterSpacing: "0.4px", 
 }}>USA</span>

  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    marginLeft: "2.6px",
    fontSize: "8.5px",        // Keep consistent base font size

  }}>
    {usaValue}
  </span>

  <span style={{
    marginLeft: "5.6px",
    letterSpacing: "0.4px",

  }}>
    MEX
  </span>

  <span 
  
  className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    letterSpacing: "0.8px",
    marginLeft: "2.48px",
    fontSize: "8.5px",        // Keep consistent base font size


  }}>
    {mexValue}
  </span>
</span>

        </div>
      )}
      {usaValue !== eurValue && category !== "Kids" && (
        <div
               className='HelveticaNeueLT57Condensed'

  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 0,
    top: "48.4%",
    width: "78.9%",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    zIndex: 2,
  }}
>
  {/* Tek bir ebeveyn span */}
  <span
               className='HelveticaNeueLT57Condensed'
    style={{
      color: "#7d7d7f",
      fontSize: "8px",
      // İsterseniz letterSpacing veya wordSpacing'i buradan da verebilirsiniz
      // letterSpacing: 0.48,
      // wordSpacing: "2px",
    }}
  >
    {/* EUR */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        // marginTop: .1 --> inline-block'ta biraz yukarı boşluk yaratabilir
      }}
    >
      EUR
    </span>

    {/* EUR Value */}
    <span
      className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      {eurValue}
    </span>

    {/* USA */}
    <span
    
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      USA
    </span>

    {/* USA Value (Bold) */}
    <span

    className='HelveticaNeueLT77BoldCondensed'
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        fontWeight: 600,
      }}
    >
      {usaValue}
    </span>

    {/* MEX */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      MEX
    </span>

    {/* MEX Value (Bold, different letterSpacing) */}
    <span
        className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.8,
        fontWeight: 600,
      }}
    >
      {mexValue}
    </span>
  </span>
</div>

      )}
      {category === "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top: "48.4%", width:"78.9%", display:"flex", justifyContent:"flex-end",zIndex:2 }}>
        <span
               className='HelveticaNeueLT57Condensed'
  style={{
    color: "#7d7d7f",
    fontSize: "8px",
    // Tek bir yerde letterSpacing ya da wordSpacing verebilirsiniz
    // letterSpacing: 0.48,
  }}
>
  {/* filteredIndo[inx]?.name */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
    }}
  >
    {filteredIndo[inx]?.name}
  </span>

  {/* 'MONTH' / 'YEARS' */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    {filteredIndo[inx]?.isMonth}
  </span>

  {/* filteredIndo[inx]?.cm?.slice(0, 3) */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
    }}
  >
    {filteredIndo[inx]?.cm?.slice(0, 3)}
  </span>

  {/* "CM" */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    CM
  </span>
</span>

        </div>
      )}
      
      {/* MADE IN Kısmı */}
      <div

  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 0,
    top: "27.15px",
    width: "84.7%",
    display: "flex",
    justifyContent: "flex-end",
    zIndex:2,
    transform: "translateY(0.7px)" 

  }}
>        <span  className='HelveticaNeueLT57Condensed' style={{ color:"#7d7d7f", fontSize:"8px", letterSpacing:0.43 }}>
          MADE IN {CountryName}
        </span>
      </div>
    </div>
  );
};

const WLZCALL031 = ({currentShape, category, referance, CountryName, filteredIndo, inx, szrgrp, valueBasedOnInx,CardBackBack}) => {
  const [TopValue, setTopValue] = useState("27px")

  // Gelen değerleri konsolda görmek için:
  console.log("USA Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.usa);
  console.log("EUR Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.europe);
  const usaValue = szrgrp?.sizes?.[valueBasedOnInx]?.usa;
  const eurValue =szrgrp?.sizes?.[valueBasedOnInx]?.europe;
  const mexValue =szrgrp?.sizes?.[valueBasedOnInx]?.mexico;
  console.log("refrefgeldi",referance)

  useEffect(() => {
    if (
      referance?.linecount === inx || // linecount, inx'e eşitse
      referance?.linecount === 0 || // linecount 0 ise
      (referance?.linecount !== 0 && inx % referance?.linecount === 0) // linecount 0 değilse ve inx'in katıysa
    ) {
      setTopValue("27.1px");
    } else {
      setTopValue("27px");

    }
  }, [referance, inx]); // 👈 Bağımlılıklar (referance veya inx değiştiğinde çalışır)
  return (
    <div style={{ position:"relative", width:"100%", minHeight:`${referance.height+2.5}mm` }}>
       {CardBackBack ? (
    <div 
      style={{
        position: "absolute", 
        top: `0`, // Her öğe için 5% fark ekleyerek aşağı kaydırıyoruz
    left: "0",

      }}
    >
      {(() => {
        const referenceCode = referance?.code;
        const referenceWidth = referance?.width;
        let width = `${referenceWidth}mm`;
        let height = "auto";

        return typeof CardBackBack === "function" ? (
          <CardBackBack width={width} height={height} />
        ) : (
          <img src={CardBackBack} alt="SVG Image" style={{ width, height }} />
        );
      })()}
    </div>
  ) : (
    <span>Loading...</span>
  )}
      <div style={{ position:"absolute", right:"28.83px", top:"31.05px" }}>
        {renderShape(currentShape, category,"#7c7d7f")}
      </div>

      {/* Şart: USA ile EUR eşitse bu bloğu döndür */}
      
      {usaValue === eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top: "33.2%", width:"78.47%", display:"flex", justifyContent:"flex-end",zIndex:2 ,    transform: "translateY(-0.2px)" }}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#767678",
    fontSize: "8px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text
  }}
>
  <span style={{ letterSpacing: "0.3px",
 }}>EUR</span>
  
  <span style={{ margin: "0 0.4px" ,   
}}>/</span>

  <span style={{ letterSpacing: "0.4px", 
 }}>USA</span>

  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    marginLeft: "2.6px",
    fontSize: "8.5px",        // Keep consistent base font size

  }}>
    {usaValue}
  </span>

  <span style={{
    marginLeft: "5.6px",
    letterSpacing: "0.4px",

  }}>
    MEX
  </span>

  <span 
  
  className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    letterSpacing: "0.8px",
    marginLeft: "2.48px",
    fontSize: "8.5px",        // Keep consistent base font size


  }}>
    {mexValue}
  </span>
</span>

        </div>
      )}
      {usaValue !== eurValue && category !== "Kids" && (
        <div
               className='HelveticaNeueLT57Condensed'

  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 0,
    top: "33.2%",
    width: "78.9%",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    zIndex: 2,
  }}
>
  {/* Tek bir ebeveyn span */}
  <span
               className='HelveticaNeueLT57Condensed'
    style={{
      color: "#767678",
      fontSize: "8px",
      // İsterseniz letterSpacing veya wordSpacing'i buradan da verebilirsiniz
      // letterSpacing: 0.48,
      // wordSpacing: "2px",
    }}
  >
    {/* EUR */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        // marginTop: .1 --> inline-block'ta biraz yukarı boşluk yaratabilir
      }}
    >
      EUR
    </span>

    {/* EUR Value */}
    <span
      className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      {eurValue}
    </span>

    {/* USA */}
    <span
    
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      USA
    </span>

    {/* USA Value (Bold) */}
    <span

    className='HelveticaNeueLT77BoldCondensed'
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        fontWeight: 600,
      }}
    >
      {usaValue}
    </span>

    {/* MEX */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      MEX
    </span>

    {/* MEX Value (Bold, different letterSpacing) */}
    <span
        className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.8,
        fontWeight: 600,
      }}
    >
      {mexValue}
    </span>
  </span>
</div>

      )}
      {category === "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top: "33.2%", width:"78.9%", display:"flex", justifyContent:"flex-end",zIndex:2 }}>
        <span
               className='HelveticaNeueLT57Condensed'
  style={{
    color: "#767678",
    fontSize: "8px",
    // Tek bir yerde letterSpacing ya da wordSpacing verebilirsiniz
    // letterSpacing: 0.48,
  }}
>
  {/* filteredIndo[inx]?.name */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
    }}
  >
    {filteredIndo[inx]?.name}
  </span>

  {/* 'MONTH' / 'YEARS' */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    {filteredIndo[inx]?.isMonth}
  </span>

  {/* filteredIndo[inx]?.cm?.slice(0, 3) */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
    }}
  >
    {filteredIndo[inx]?.cm?.slice(0, 3)}
  </span>

  {/* "CM" */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    CM
  </span>
</span>

        </div>
      )}
      
      {/* MADE IN Kısmı */}
      <div

  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 0,
    top: "37.1px",
    width: "78.87%",
    display: "flex",
    justifyContent: "flex-end",
    zIndex:2,
    transform: "translateY(0.5px)" 

  }}
>        <span  className='HelveticaNeueLT57Condensed' style={{ color:"#767678", fontSize:"8px", letterSpacing:0.43 }}>
          MADE IN {CountryName}
        </span>
      </div>
    </div>
  );
};
const WLZCALL035 = ({currentShape, category, referance, CountryName, filteredIndo, inx, szrgrp, valueBasedOnInx,CardBackBack}) => {
  const [TopValue, setTopValue] = useState("27px")

  // Gelen değerleri konsolda görmek için:
  console.log("USA Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.usa);
  console.log("EUR Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.europe);
  const usaValue = szrgrp?.sizes?.[valueBasedOnInx]?.usa;
  const eurValue =szrgrp?.sizes?.[valueBasedOnInx]?.europe;
  const mexValue =szrgrp?.sizes?.[valueBasedOnInx]?.mexico;
  console.log("refrefgeldi",referance)

  useEffect(() => {
    if (
      referance?.linecount === inx || // linecount, inx'e eşitse
      referance?.linecount === 0 || // linecount 0 ise
      (referance?.linecount !== 0 && inx % referance?.linecount === 0) // linecount 0 değilse ve inx'in katıysa
    ) {
      setTopValue("27.1px");
    } else {
      setTopValue("27px");

    }
  }, [referance, inx]); // 👈 Bağımlılıklar (referance veya inx değiştiğinde çalışır)
  return (
    <div style={{ position:"relative", width:"100%", minHeight:`${referance.height}mm` }}>
       {CardBackBack ? (
    <div 
      style={{
        position: "absolute", 
        top: `0`, // Her öğe için 5% fark ekleyerek aşağı kaydırıyoruz
    left: "0",

      }}
    >
      {(() => {
        const referenceCode = referance?.code;
        const referenceWidth = referance?.width;
        let width = `${referenceWidth}mm`;
        let height = "auto";

        return typeof CardBackBack === "function" ? (
          <CardBackBack width={width} height={height} />
        ) : (
          <img src={CardBackBack} alt="SVG Image" style={{ width, height }} />
        );
      })()}
    </div>
  ) : (
    <span>Loading...</span>
  )}
      <div style={{ position:"absolute", right:"48.5px", bottom:"92px" }}>
        {renderShape(currentShape, category,"#7c7d7f")}
      </div>

      {/* Şart: USA ile EUR eşitse bu bloğu döndür */}
      
      {usaValue === eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top: "35%", width:"93.3%",marginLeft:4, display:"flex", justifyContent:"center",zIndex:2,    transform: "translateX(0.4px)" 
 }}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#B1B4B3",
    fontSize: "7.7px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text
  }}
>
  <span style={{ letterSpacing: "0.3px",
 }}>EUR</span>
  
  <span style={{ margin: "0 0.4px" ,   
}}>/</span>

  <span style={{ letterSpacing: "0.4px", 
 }}>USA</span>

  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{

    fontWeight: 900,
    marginLeft:"2.2px",
    fontSize: "8.2px",        // Keep consistent base font size

  }}>
    {usaValue}
  </span>

  <span style={{
        marginLeft:"5px",

    letterSpacing: "0.4px",

  }}>
    MEX
  </span>

  <span 
  
  className='HelveticaNeueLT77BoldCondensed'

  style={{
    marginLeft:"2.2px",

    fontWeight: 900,
    letterSpacing: "0.4px",
    fontSize: "8.2px",        // Keep consistent base font size


  }}>
    {mexValue}
  </span>
</span>

        </div>
      )}
      {usaValue !== eurValue && category !== "Kids" && (
        <div
style={{ border:"1px solid transparent", position:"absolute", left:0, top: "35%", width:"93.3%",marginLeft:4, display:"flex", justifyContent:"center",zIndex:2,    transform: "translateX(0.4px)" 
 }}
>
  {/* Tek bir ebeveyn span */}
  <span
               className='HelveticaNeueLT57Condensed'
    style={{
      color: "#B1B4B3",
      fontSize: "7.7px",
      // İsterseniz letterSpacing veya wordSpacing'i buradan da verebilirsiniz
      // letterSpacing: 0.48,
      // wordSpacing: "2px",
    }}
  >
    {/* EUR */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        // marginTop: .1 --> inline-block'ta biraz yukarı boşluk yaratabilir
      }}
    >
      EUR
    </span>

    {/* EUR Value */}
    <span
      className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      {eurValue}
    </span>

    {/* USA */}
    <span
    
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      USA
    </span>

    {/* USA Value (Bold) */}
    <span

    className='HelveticaNeueLT77BoldCondensed'
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        fontWeight: 600,
        fontSize: "8.2px",        // Keep consistent base font size

      }}
    >
      {usaValue}
    </span>

    {/* MEX */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      MEX
    </span>

    {/* MEX Value (Bold, different letterSpacing) */}
    <span
        className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.8,
        fontWeight: 600,
        fontSize: "8.2px",        // Keep consistent base font size

      }}
    >
      {mexValue}
    </span>
  </span>
</div>

      )}
      {category === "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top: "35%", width:"93.3%",marginLeft:4, display:"flex", justifyContent:"center",zIndex:2,    transform: "translateX(0.4px)" 
 }}>
        <span
               className='HelveticaNeueLT57Condensed'
  style={{
    color: "#B1B4B3",
    fontSize: "7.7px",
    // Tek bir yerde letterSpacing ya da wordSpacing verebilirsiniz
    // letterSpacing: 0.48,
  }}
>
  {/* filteredIndo[inx]?.name */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontSize: "8.2px",        // Keep consistent base font size

    }}
  >
    {filteredIndo[inx]?.name}
  </span>

  {/* 'MONTH' / 'YEARS' */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    {filteredIndo[inx]?.isMonth}
  </span>

  {/* filteredIndo[inx]?.cm?.slice(0, 3) */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontSize: "8.2px",        // Keep consistent base font size

    }}
  >
    {filteredIndo[inx]?.cm?.slice(0, 3)}
  </span>

  {/* "CM" */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    CM
  </span>
</span>

        </div>
      )}
      
      {/* MADE IN Kısmı */}
      <div

  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 0,
    marginLeft:4.4,
    top: "102px",
    width:"93.3%",
    display: "flex",
    justifyContent: "center",
    zIndex:2,
    transform: "translateY(0.9px)" 

  }}
>        <span  className='HelveticaNeueLT57Condensed' style={{ color:"#B1B4B3", fontSize:"7.7px", letterSpacing:0.4 }}>
          MADE IN {CountryName}
        </span>
      </div>
    </div>
  );
};


const WLZCALL036 = ({currentShape, category, referance, CountryName, filteredIndo, inx, szrgrp, valueBasedOnInx,CardBackBack}) => {
  const [TopValue, setTopValue] = useState("27px")

  // Gelen değerleri konsolda görmek için:
  console.log("USA Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.usa);
  console.log("EUR Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.europe);
  const usaValue = szrgrp?.sizes?.[valueBasedOnInx]?.usa;
  const eurValue =szrgrp?.sizes?.[valueBasedOnInx]?.europe;
  const mexValue =szrgrp?.sizes?.[valueBasedOnInx]?.mexico;
  console.log("refrefgeldi",referance)

  useEffect(() => {
    if (
      referance?.linecount === inx || // linecount, inx'e eşitse
      referance?.linecount === 0 || // linecount 0 ise
      (referance?.linecount !== 0 && inx % referance?.linecount === 0) // linecount 0 değilse ve inx'in katıysa
    ) {
      setTopValue("27.1px");
    } else {
      setTopValue("27px");

    }
  }, [referance, inx]); // 👈 Bağımlılıklar (referance veya inx değiştiğinde çalışır)
  return (
    <div style={{ position:"relative", width:"100%", minHeight:`${referance.height}mm` }}>
       {CardBackBack ? (
    <div 
      style={{
        position: "absolute", 
        top: `0`, // Her öğe için 5% fark ekleyerek aşağı kaydırıyoruz
    left: "0",

      }}
    >
      {(() => {
        const referenceCode = referance?.code;
        const referenceWidth = referance?.width;
        let width = `${referenceWidth}mm`;
        let height = "auto";

        return typeof CardBackBack === "function" ? (
          <CardBackBack width={width} height={height} />
        ) : (
          <img src={CardBackBack} alt="SVG Image" style={{ width, height }} />
        );
      })()}
    </div>
  ) : (
    <span>Loading...</span>
  )}
      <div style={{ position:"absolute", right:"48.5px", bottom:"92px" }}>
        {renderShape(currentShape, category,"#7c7d7f")}
      </div>

      {/* Şart: USA ile EUR eşitse bu bloğu döndür */}
      
      {usaValue === eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top: "34.9%", width:"92%",marginLeft:4, display:"flex", justifyContent:"center",zIndex:2,    transform: "translateX(0.4px)" 
 }}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#7d7d7f",
    fontSize: "7.7px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text
  }}
>
  <span style={{ letterSpacing: "0.35px",
 }}>EUR</span>
  
  <span style={{ margin: "0 0.4px" ,   
}}>/</span>

  <span style={{ letterSpacing: "0.35px", 
 }}>USA</span>

  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{

    fontWeight: 900,
    marginLeft:"2.2px",
    fontSize: "8.2px",        // Keep consistent base font size

  }}>
    {usaValue}
  </span>

  <span style={{
        marginLeft:"5px",

    letterSpacing: "0.35px",

  }}>
    MEX
  </span>

  <span 
  
  className='HelveticaNeueLT77BoldCondensed'

  style={{
    marginLeft:"2.2px",

    fontWeight: 900,
    letterSpacing: "0.35px",
    fontSize: "8.2px",        // Keep consistent base font size


  }}>
    {mexValue}
  </span>
</span>

        </div>
      )}
      {usaValue !== eurValue && category !== "Kids" && (
        <div
style={{ border:"1px solid transparent", position:"absolute", left:0, top: "34.9%", width:"92%",marginLeft:4, display:"flex", justifyContent:"center",zIndex:2,    transform: "translateX(0.4px)" 
 }}
>
  {/* Tek bir ebeveyn span */}
  <span
               className='HelveticaNeueLT57Condensed'
    style={{
      color: "#7d7d7f",
      fontSize: "7.7px",
      // İsterseniz letterSpacing veya wordSpacing'i buradan da verebilirsiniz
      // letterSpacing: 0.48,
      // wordSpacing: "2px",
    }}
  >
    {/* EUR */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        // marginTop: .1 --> inline-block'ta biraz yukarı boşluk yaratabilir
      }}
    >
      EUR
    </span>

    {/* EUR Value */}
    <span
      className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      {eurValue}
    </span>

    {/* USA */}
    <span
    
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      USA
    </span>

    {/* USA Value (Bold) */}
    <span

    className='HelveticaNeueLT77BoldCondensed'
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        fontWeight: 600,
        fontSize: "8.2px",        // Keep consistent base font size

      }}
    >
      {usaValue}
    </span>

    {/* MEX */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      MEX
    </span>

    {/* MEX Value (Bold, different letterSpacing) */}
    <span
        className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.8,
        fontWeight: 600,
        fontSize: "8.2px",        // Keep consistent base font size

      }}
    >
      {mexValue}
    </span>
  </span>
</div>

      )}
      {category === "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top: "34.9%", width:"92%",marginLeft:4, display:"flex", justifyContent:"center",zIndex:2,    transform: "translateX(0.4px)" 
 }}>
        <span
               className='HelveticaNeueLT57Condensed'
  style={{
    color: "#7d7d7f",
    fontSize: "7.7px",
    // Tek bir yerde letterSpacing ya da wordSpacing verebilirsiniz
    // letterSpacing: 0.48,
  }}
>
  {/* filteredIndo[inx]?.name */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontSize: "8.2px",        // Keep consistent base font size

    }}
  >
    {filteredIndo[inx]?.name}
  </span>

  {/* 'MONTH' / 'YEARS' */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    {filteredIndo[inx]?.isMonth}
  </span>

  {/* filteredIndo[inx]?.cm?.slice(0, 3) */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontSize: "8.2px",        // Keep consistent base font size

    }}
  >
    {filteredIndo[inx]?.cm?.slice(0, 3)}
  </span>

  {/* "CM" */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    CM
  </span>
</span>

        </div>
      )}
      
      {/* MADE IN Kısmı */}
      <div

  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 0,
    marginLeft:4.4,
    top: "101.8px",
    width:"92%",
    display: "flex",
    justifyContent: "center",
    zIndex:2,
    transform: "translateY(0.7px)" 

  }}
>        <span  className='HelveticaNeueLT57Condensed' style={{ color:"#7d7d7f", fontSize:"7.7px", letterSpacing:0.36 }}>
          MADE IN {CountryName}
        </span>
      </div>
    </div>
  );
};

const WPZCALL001 = ({currentShape, category, referance, CountryName, filteredIndo, inx, szrgrp, valueBasedOnInx,CardBackBack}) => {
  const [TopValue, setTopValue] = useState("27px")

  // Gelen değerleri konsolda görmek için:
  console.log("USA Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.usa);
  console.log("EUR Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.europe);
  const usaValue = szrgrp?.sizes?.[valueBasedOnInx]?.usa;
  const eurValue =szrgrp?.sizes?.[valueBasedOnInx]?.europe;
  const mexValue =szrgrp?.sizes?.[valueBasedOnInx]?.mexico;
  console.log("refrefgeldi",referance)

  useEffect(() => {
    if (
      referance?.linecount === inx || // linecount, inx'e eşitse
      referance?.linecount === 0 || // linecount 0 ise
      (referance?.linecount !== 0 && inx % referance?.linecount === 0) // linecount 0 değilse ve inx'in katıysa
    ) {
      setTopValue("27.1px");
    } else {
      setTopValue("27px");

    }
  }, [referance, inx]); // 👈 Bağımlılıklar (referance veya inx değiştiğinde çalışır)
  return (
    <div style={{ position:"relative", width:"100%", minHeight:`${referance.height}mm` }}>
       {CardBackBack ? (
    <div 
      style={{
        position: "absolute", 
        top: `0`, // Her öğe için 5% fark ekleyerek aşağı kaydırıyoruz
    left: "0",

      }}
    >
      {(() => {
        const referenceCode = referance?.code;
        const referenceWidth = referance?.width;
        let width = `${referenceWidth}mm`;
        let height = "auto";

        return typeof CardBackBack === "function" ? (
          <CardBackBack width={width} height={height} />
        ) : (
          <img src={CardBackBack} alt="SVG Image" style={{ width, height }} />
        );
      })()}
    </div>
  ) : (
    <span>Loading...</span>
  )}
      <div style={{ position:"absolute", right:"58px", bottom:"132.1px" }}>
      {renderShape(currentShape, category, "#b1b4b3")}
      </div>

      {/* Şart: USA ile EUR eşitse bu bloğu döndür */}
      
      {usaValue === eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top: "36%", width:"94.4%",marginLeft:4, display:"flex", justifyContent:"center",zIndex:2,    transform: "translateX(0.4px)" 
 }}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#b1b4b3",
    fontSize: "7.7px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text
  }}
>
  <span style={{ letterSpacing: "0.3px",
 }}>EUR</span>
  
  <span style={{ margin: "0 0.4px" ,   
}}>/</span>

  <span style={{ letterSpacing: "0.4px", 
 }}>USA</span>

  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{

    fontWeight: 900,
    marginLeft:"2.2px",
    fontSize: "8.2px",        // Keep consistent base font size

  }}>
    {usaValue}
  </span>

  <span style={{
        marginLeft:"5px",

    letterSpacing: "0.4px",

  }}>
    MEX
  </span>

  <span 
  
  className='HelveticaNeueLT77BoldCondensed'

  style={{
    marginLeft:"2.2px",

    fontWeight: 900,
    letterSpacing: "0.5px",
    fontSize: "8.2px",        // Keep consistent base font size


  }}>
    {mexValue}
  </span>
</span>

        </div>
      )}
      {usaValue !== eurValue && category !== "Kids" && (
        <div
style={{ border:"1px solid transparent", position:"absolute", left:0, top: "36%", width:"94.4%",marginLeft:4, display:"flex", justifyContent:"center",zIndex:2,    transform: "translateX(0.4px)" 
 }}
>
  {/* Tek bir ebeveyn span */}
  <span
               className='HelveticaNeueLT57Condensed'
    style={{
      color: "#B1B4B3",
      fontSize: "7.7px",
      // İsterseniz letterSpacing veya wordSpacing'i buradan da verebilirsiniz
      // letterSpacing: 0.48,
      // wordSpacing: "2px",
    }}
  >
    {/* EUR */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        // marginTop: .1 --> inline-block'ta biraz yukarı boşluk yaratabilir
      }}
    >
      EUR
    </span>

    {/* EUR Value */}
    <span
      className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      {eurValue}
    </span>

    {/* USA */}
    <span
    
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      USA
    </span>

    {/* USA Value (Bold) */}
    <span

    className='HelveticaNeueLT77BoldCondensed'
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        fontWeight: 600,
        fontSize: "8.2px",        // Keep consistent base font size

      }}
    >
      {usaValue}
    </span>

    {/* MEX */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      MEX
    </span>

    {/* MEX Value (Bold, different letterSpacing) */}
    <span
        className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.8,
        fontWeight: 600,
        fontSize: "8.2px",        // Keep consistent base font size

      }}
    >
      {mexValue}
    </span>
  </span>
</div>

      )}
      {category === "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top: "36%", width:"94.4%",marginLeft:4, display:"flex", justifyContent:"center",zIndex:2,    transform: "translateX(0.4px)" 
 }}>
        <span
               className='HelveticaNeueLT57Condensed'
  style={{
    color: "#B1B4B3",
    fontSize: "7.7px",
    // Tek bir yerde letterSpacing ya da wordSpacing verebilirsiniz
    // letterSpacing: 0.48,
  }}
>
  {/* filteredIndo[inx]?.name */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontSize: "8.2px",        // Keep consistent base font size

    }}
  >
    {filteredIndo[inx]?.name}
  </span>

  {/* 'MONTH' / 'YEARS' */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    {filteredIndo[inx]?.isMonth}
  </span>

  {/* filteredIndo[inx]?.cm?.slice(0, 3) */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontSize: "8.2px",        // Keep consistent base font size

    }}
  >
    {filteredIndo[inx]?.cm?.slice(0, 3)}
  </span>

  {/* "CM" */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    CM
  </span>
</span>

        </div>
      )}
      
      {/* MADE IN Kısmı */}
      <div

  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 0,
    marginLeft:4.4,
    top: "134px",
    width:"94.4%",
    display: "flex",
    justifyContent: "center",
    zIndex:2,
    transform: "translateY(0.9px)" 

  }}
>        <span  className='HelveticaNeueLT57Condensed' style={{ color:"#b1b4b3", fontSize:"7.7px", letterSpacing:0.45 }}>
          MADE IN {CountryName}
        </span>
      </div>
    </div>
  );
};


const WPZCALL002 = ({currentShape, category, referance, CountryName, filteredIndo, inx, szrgrp, valueBasedOnInx,CardBackBack}) => {
  const [TopValue, setTopValue] = useState("27px")

  // Gelen değerleri konsolda görmek için:
  console.log("USA Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.usa);
  console.log("EUR Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.europe);
  const usaValue = szrgrp?.sizes?.[valueBasedOnInx]?.usa;
  const eurValue =szrgrp?.sizes?.[valueBasedOnInx]?.europe;
  const mexValue =szrgrp?.sizes?.[valueBasedOnInx]?.mexico;
  console.log("refrefgeldi",referance)

  useEffect(() => {
    if (
      referance?.linecount === inx || // linecount, inx'e eşitse
      referance?.linecount === 0 || // linecount 0 ise
      (referance?.linecount !== 0 && inx % referance?.linecount === 0) // linecount 0 değilse ve inx'in katıysa
    ) {
      setTopValue("27.1px");
    } else {
      setTopValue("27px");

    }
  }, [referance, inx]); // 👈 Bağımlılıklar (referance veya inx değiştiğinde çalışır)
  return (
    <div style={{ position:"relative", width:"100%", minHeight:`${referance.height+2.5}mm` }}>
       {CardBackBack ? (
    <div 
      style={{
        position: "absolute", 
        top: `0`, // Her öğe için 5% fark ekleyerek aşağı kaydırıyoruz
    left: "0",

      }}
    >
      {(() => {
        const referenceCode = referance?.code;
        const referenceWidth = referance?.width;
        let width = `${referenceWidth}mm`;
        let height = "auto";

        return typeof CardBackBack === "function" ? (
          <CardBackBack width={width} height={height} />
        ) : (
          <img src={CardBackBack} alt="SVG Image" style={{ width, height }} />
        );
      })()}
    </div>
  ) : (
    <span>Loading...</span>
  )}


      {/* Şart: USA ile EUR eşitse bu bloğu döndür */}
      
      {usaValue === eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top: "33.2%", width:"83.75%", display:"flex", justifyContent:"flex-end",zIndex:2,    transform: "translateY(0.2px)" 
}}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#B1B4B3",
    fontSize: "7.3px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text
  }}
>
  <span style={{ letterSpacing: "0.35px",
 }}>EUR</span>
  
  <span style={{ margin: "0 0.4px" ,   
}}>/</span>

  <span style={{ letterSpacing: "0.5px", marginLeft:"0.2px"
 }}>USA</span>

  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{

    fontWeight: 900,
    marginLeft:"2px",
    fontSize: "8px",        // Keep consistent base font size

  }}>
    {usaValue}
  </span>

  <span style={{
        marginLeft:"5.2px",

    letterSpacing: "0.4px",

  }}>
    MEX
  </span>

  <span 
  
  className='HelveticaNeueLT77BoldCondensed'

  style={{
    marginLeft:"2.1px",

    fontWeight: 900,
    letterSpacing: "0.45px",
    fontSize: "8px",        // Keep consistent base font size


  }}>
    {mexValue}
  </span>
</span>


        </div>
      )}
      {usaValue !== eurValue && category !== "Kids" && (
        <div
               className='HelveticaNeueLT57Condensed'

  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 0,
    top: "33.2%",
    width:"83.75%",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    zIndex: 2,
  }}
>
  {/* Tek bir ebeveyn span */}
  <span
               className='HelveticaNeueLT57Condensed'
    style={{
      color: "#B1B4B3",
      fontSize: "7.3px",
      // İsterseniz letterSpacing veya wordSpacing'i buradan da verebilirsiniz
      // letterSpacing: 0.48,
      // wordSpacing: "2px",
    }}
  >
    {/* EUR */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        // marginTop: .1 --> inline-block'ta biraz yukarı boşluk yaratabilir
      }}
    >
      EUR
    </span>

    {/* EUR Value */}
    <span
      className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      {eurValue}
    </span>

    {/* USA */}
    <span
    
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      USA
    </span>

    {/* USA Value (Bold) */}
    <span

    className='HelveticaNeueLT77BoldCondensed'
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        fontWeight: 600,
      }}
    >
      {usaValue}
    </span>

    {/* MEX */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      MEX
    </span>

    {/* MEX Value (Bold, different letterSpacing) */}
    <span
        className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.8,
        fontWeight: 600,
      }}
    >
      {mexValue}
    </span>
  </span>
</div>

      )}
      {category === "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top: "33.2%", width:"83.75%", display:"flex", justifyContent:"flex-end",zIndex:2 }}>
        <span
               className='HelveticaNeueLT57Condensed'
  style={{
    color: "#B1B4B3",
    fontSize: "7.3px",
    // Tek bir yerde letterSpacing ya da wordSpacing verebilirsiniz
    // letterSpacing: 0.48,
  }}
>
  {/* filteredIndo[inx]?.name */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
    }}
  >
    {filteredIndo[inx]?.name}
  </span>

  {/* 'MONTH' / 'YEARS' */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    {filteredIndo[inx]?.isMonth}
  </span>

  {/* filteredIndo[inx]?.cm?.slice(0, 3) */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
    }}
  >
    {filteredIndo[inx]?.cm?.slice(0, 3)}
  </span>

  {/* "CM" */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    CM
  </span>
</span>

        </div>
      )}
      
      {/* MADE IN Kısmı */}
      <div

  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 0,
    top: "29.5px",
    width:"83.77%",
    display: "flex",
    justifyContent: "flex-end",
    zIndex:2,
    transform: "translateY(0.6px)" 

  }}
>        <span  className='HelveticaNeueLT57Condensed' style={{ color:"#B1B4B3", fontSize:"7.3px", letterSpacing:0.53 }}>
          MADE IN {CountryName}
        </span>
      </div>
    </div>
  );
};
const WPZCALL003 = ({currentShape, category, referance, CountryName, filteredIndo, inx, szrgrp, valueBasedOnInx,CardBackBack}) => {
  const [TopValue, setTopValue] = useState("27px")

  // Gelen değerleri konsolda görmek için:
  console.log("USA Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.usa);
  console.log("EUR Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.europe);
  const usaValue = szrgrp?.sizes?.[valueBasedOnInx]?.usa;
  const eurValue =szrgrp?.sizes?.[valueBasedOnInx]?.europe;
  const mexValue =szrgrp?.sizes?.[valueBasedOnInx]?.mexico;
  console.log("refrefgeldi",referance)

  useEffect(() => {
    if (
      referance?.linecount === inx || // linecount, inx'e eşitse
      referance?.linecount === 0 || // linecount 0 ise
      (referance?.linecount !== 0 && inx % referance?.linecount === 0) // linecount 0 değilse ve inx'in katıysa
    ) {
      setTopValue("27.1px");
    } else {
      setTopValue("27px");

    }
  }, [referance, inx]); // 👈 Bağımlılıklar (referance veya inx değiştiğinde çalışır)
  return (
    <div style={{ position:"relative", width:"100%", minHeight:`${referance.height+2.5}mm` }}>
       {CardBackBack ? (
    <div 
      style={{
        position: "absolute", 
        top: `0`, // Her öğe için 5% fark ekleyerek aşağı kaydırıyoruz
    left: "0",

      }}
    >
      {(() => {
        const referenceCode = referance?.code;
        const referenceWidth = referance?.width;
        let width = `${referenceWidth}mm`;
        let height = "auto";

        return typeof CardBackBack === "function" ? (
          <CardBackBack width={width} height={height} />
        ) : (
          <img src={CardBackBack} alt="SVG Image" style={{ width, height }} />
        );
      })()}
    </div>
  ) : (
    <span>Loading...</span>
  )}
      <div style={{ position:"absolute", right:"12.83px", top:"21.5px" }}>
        {renderShape(currentShape, category,"#b2b5b4")}
      </div>

      {/* Şart: USA ile EUR eşitse bu bloğu döndür */}
      
      {usaValue === eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top:"18.9px", width:"84.7%", display:"flex", justifyContent:"flex-end",zIndex:2,alignItems:"center",    transform: "translateY(0.5px)" 
 }}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#b2b5b4",
    fontSize: "8px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text
  }}
>
  <span style={{ letterSpacing: "0.35px",
 }}>EUR</span>
  
  <span style={{ margin: "0 0.4px" ,   
}}>/</span>

  <span style={{ letterSpacing: "0.4px", 
 }}>USA</span>

  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    marginLeft: "2.6px",
    fontSize: "8.5px",        // Keep consistent base font size

  }}>
    {usaValue}
  </span>

  <span style={{
    marginLeft: "5.6px",
    letterSpacing: "0.4px",

  }}>
    MEX
  </span>

  <span 
  
  className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    letterSpacing: "0.8px",
    marginLeft: "2.5px",
    fontSize: "8.5px",        // Keep consistent base font size


  }}>
    {mexValue}
  </span>
</span>

        </div>
      )}
      {usaValue !== eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0,top:"18.9px", width:"84.7%", display:"flex", justifyContent:"flex-end",zIndex:2,alignItems:"center"}}>
        <span
               className='HelveticaNeueLT57Condensed'
    style={{
      color: "#b2b5b4",
      fontSize: "8px",
      // İsterseniz letterSpacing veya wordSpacing'i buradan da verebilirsiniz
      // letterSpacing: 0.48,
      // wordSpacing: "2px",
    }}
  >
    {/* EUR */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        // marginTop: .1 --> inline-block'ta biraz yukarı boşluk yaratabilir
      }}
    >
      EUR
    </span>

    {/* EUR Value */}
    <span
      className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      {eurValue}
    </span>

    {/* USA */}
    <span
    
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      USA
    </span>

    {/* USA Value (Bold) */}
    <span

    className='HelveticaNeueLT77BoldCondensed'
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        fontWeight: 600,
      }}
    >
      {usaValue}
    </span>

    {/* MEX */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      MEX
    </span>

    {/* MEX Value (Bold, different letterSpacing) */}
    <span
        className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.8,
        fontWeight: 600,
      }}
    >
      {mexValue}
    </span>
  </span>
        </div>
      )}
      {category === "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top:"18.9px", width:"84.7%",display:"flex", justifyContent:"flex-end",zIndex:2 }}>
        <span
               className='HelveticaNeueLT57Condensed'
  style={{
    color: "#b2b5b4",
    fontSize: "8px",
    // Tek bir yerde letterSpacing ya da wordSpacing verebilirsiniz
    // letterSpacing: 0.48,
  }}
>
  {/* filteredIndo[inx]?.name */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      marginTop: 0.1, 
    }}
  >
    {filteredIndo[inx]?.name}
  </span>

  {/* 'MONTH' / 'YEARS' */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    {filteredIndo[inx]?.isMonth}
  </span>

  {/* filteredIndo[inx]?.cm?.slice(0, 3) */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      marginTop: 0.1, 
    }}
  >
    {filteredIndo[inx]?.cm?.slice(0, 3)}
  </span>

  {/* "CM" */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    CM
  </span>
</span>
        </div>
      )}
      
      {/* MADE IN Kısmı */}
      <div
  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 0,
    top: "27.3px",
  
  width:"84.4%",
    display: "flex",
    justifyContent: "flex-end",
    zIndex:2,
    transform: "translateY(0.3px)"
  }}
>        <span   className='HelveticaNeueLT57Condensed' style={{ color:"#b2b5b4", fontSize:"8px", letterSpacing:0.48, marginTop:.1 }}>
          MADE IN {CountryName}
        </span>
      </div>
    </div>
  );
};
const WPZCALL004 = ({currentShape, category, referance, CountryName, filteredIndo, inx, szrgrp, valueBasedOnInx,CardBackBack}) => {
  const [TopValue, setTopValue] = useState("27px")

  // Gelen değerleri konsolda görmek için:
  console.log("USA Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.usa);
  console.log("EUR Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.europe);
  const usaValue = szrgrp?.sizes?.[valueBasedOnInx]?.usa;
  const eurValue =szrgrp?.sizes?.[valueBasedOnInx]?.europe;
  const mexValue =szrgrp?.sizes?.[valueBasedOnInx]?.mexico;
  console.log("refrefgeldi",referance)

  useEffect(() => {
    if (
      referance?.linecount === inx || // linecount, inx'e eşitse
      referance?.linecount === 0 || // linecount 0 ise
      (referance?.linecount !== 0 && inx % referance?.linecount === 0) // linecount 0 değilse ve inx'in katıysa
    ) {
      setTopValue("27.1px");
    } else {
      setTopValue("27px");

    }
  }, [referance, inx]); // 👈 Bağımlılıklar (referance veya inx değiştiğinde çalışır)
  return (
    <div style={{ position:"relative", width:"100%", minHeight:`${referance.height+2.5}mm` }}>
       {CardBackBack ? (
    <div 
      style={{
        position: "absolute", 
        top: `0`, // Her öğe için 5% fark ekleyerek aşağı kaydırıyoruz
    left: "0",

      }}
    >
      {(() => {
        const referenceCode = referance?.code;
        const referenceWidth = referance?.width;
        let width = `${referenceWidth}mm`;
        let height = "auto";

        return typeof CardBackBack === "function" ? (
          <CardBackBack width={width} height={height} />
        ) : (
          <img src={CardBackBack} alt="SVG Image" style={{ width, height }} />
        );
      })()}
    </div>
  ) : (
    <span>Loading...</span>
  )}
      <div style={{ position:"absolute", right:"30.83px", top:"37px" }}>
        {renderShape(currentShape, category,"#7c7d7f")}
      </div>

      {/* Şart: USA ile EUR eşitse bu bloğu döndür */}
      
      {usaValue === eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top:"34.7px", width:"76.7%", display:"flex", justifyContent:"flex-end",zIndex:2,alignItems:"center",    transform: "translateY(0.5px)" 
 }}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#bbbebd",
    fontSize: "7.5px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text
  }}
>
  <span style={{ 
 }}>EUR</span>
  
  <span style={{ margin: "0 0.3px" ,   
}}>/</span>

  <span style={{ 
 }}>USA</span>

  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    marginLeft: "2.2px",
    fontSize: "8px",        // Keep consistent base font size

  }}>
    {usaValue}
  </span>

  <span style={{
    marginLeft: "4.3px",
 

  }}>
    MEX
  </span>

  <span 
  
  className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,

    marginLeft: "2.5px",
    fontSize: "8px",        // Keep consistent base font size


  }}>
    {mexValue}
  </span>
</span>

        </div>
      )}
      {usaValue !== eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top:"34.7px", width:"76.7%", display:"flex", justifyContent:"flex-end",zIndex:2,alignItems:"center"}}>
        <span
               className='HelveticaNeueLT57Condensed'
    style={{
      color: "#bbbebd",
      fontSize: "7.5px",
      // İsterseniz letterSpacing veya wordSpacing'i buradan da verebilirsiniz
      // letterSpacing: 0.48,
      // wordSpacing: "2px",
    }}
  >
    {/* EUR */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        // marginTop: .1 --> inline-block'ta biraz yukarı boşluk yaratabilir
      }}
    >
      EUR
    </span>

    {/* EUR Value */}
    <span
      className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
      }}
    >
      {eurValue}
    </span>

    {/* USA */}
    <span
    
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      USA
    </span>

    {/* USA Value (Bold) */}
    <span

    className='HelveticaNeueLT77BoldCondensed'
      style={{
        display: "inline-block",
        marginLeft: 2,
        fontWeight: 600,
      }}
    >
      {usaValue}
    </span>

    {/* MEX */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
      }}
    >
      MEX
    </span>

    {/* MEX Value (Bold, different letterSpacing) */}
    <span
        className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        fontWeight: 600,
      }}
    >
      {mexValue}
    </span>
  </span>
        </div>
      )}
      {category === "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0,  top:"34.7px", width:"76.7%",display:"flex", justifyContent:"flex-end",zIndex:2 }}>
        <span
               className='HelveticaNeueLT57Condensed'
  style={{
    color: "#bbbebd",
    fontSize: "7.5px",
    // Tek bir yerde letterSpacing ya da wordSpacing verebilirsiniz
    // letterSpacing: 0.48,
  }}
>
  {/* filteredIndo[inx]?.name */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      marginTop: 0.1, 
    }}
  >
    {filteredIndo[inx]?.name}
  </span>

  {/* 'MONTH' / 'YEARS' */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      fontWeight: 600,
    }}
  >
    {filteredIndo[inx]?.isMonth}
  </span>

  {/* filteredIndo[inx]?.cm?.slice(0, 3) */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      marginTop: 0.1, 
    }}
  >
    {filteredIndo[inx]?.cm?.slice(0, 3)}
  </span>

  {/* "CM" */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      fontWeight: 600,
    }}
  >
    CM
  </span>
</span>
        </div>
      )}
      
      {/* MADE IN Kısmı */}
      <div
  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 0,
    top: "42.9px",
 width:"76.7%",

    display: "flex",
    justifyContent: "flex-end",
    zIndex:2,
    transform: "translateY(0.3px)"
  }}
>        <span   className='HelveticaNeueLT57Condensed' style={{ color:"#bbbebd", fontSize: "7.4px", marginTop:.1 ,letterSpacing:"0.15px"}}>
          MADE IN {CountryName}
        </span>
      </div>
    </div>
  );
};


const WPZCALL005 = ({currentShape, category, referance, CountryName, filteredIndo, inx, szrgrp, valueBasedOnInx,CardBackBack}) => {
  const [TopValue, setTopValue] = useState("27px")

  // Gelen değerleri konsolda görmek için:
  console.log("USA Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.usa);
  console.log("EUR Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.europe);
  const usaValue = szrgrp?.sizes?.[valueBasedOnInx]?.usa;
  const eurValue =szrgrp?.sizes?.[valueBasedOnInx]?.europe;
  const mexValue =szrgrp?.sizes?.[valueBasedOnInx]?.mexico;
  console.log("refrefgeldi",referance)

  useEffect(() => {
    if (
      referance?.linecount === inx || // linecount, inx'e eşitse
      referance?.linecount === 0 || // linecount 0 ise
      (referance?.linecount !== 0 && inx % referance?.linecount === 0) // linecount 0 değilse ve inx'in katıysa
    ) {
      setTopValue("27.1px");
    } else {
      setTopValue("27px");

    }
  }, [referance, inx]); // 👈 Bağımlılıklar (referance veya inx değiştiğinde çalışır)
  return (
    <div style={{ position:"relative", width:"100%", minHeight:`${referance.height+2.5}mm` }}>
       {CardBackBack ? (
    <div 
      style={{
        position: "absolute", 
        top: `0`, // Her öğe için 5% fark ekleyerek aşağı kaydırıyoruz
    left: "0",

      }}
    >
      {(() => {
        const referenceCode = referance?.code;
        const referenceWidth = referance?.width;
        let width = `${referenceWidth}mm`;
        let height = "auto";

        return typeof CardBackBack === "function" ? (
          <CardBackBack width={width} height={height} />
        ) : (
          <img src={CardBackBack} alt="SVG Image" style={{ width, height }} />
        );
      })()}
    </div>
  ) : (
    <span>Loading...</span>
  )}
      <div style={{ position:"absolute", right:"28.83px", top:"84.5px" }}>
        {renderShape(currentShape, category,"#7c7d7f")}
      </div>

      {/* Şart: USA ile EUR eşitse bu bloğu döndür */}
      
      {usaValue === eurValue && category !== "Kids" && (
        <>
        <div style={{ border:"1px solid transparent", position:"absolute", left:2.5, top:"27.4px", width:"93.2%", display:"flex", justifyContent:"center",zIndex:2,alignItems:"center",    transform: "translateY(0.5px)" 
 }}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#b2b5b4",
    fontSize: "7.5px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text
  }}
>
  <span style={{ letterSpacing: "0.35px",
 }}>EUR</span>
  
  <span style={{ margin: "0 0.35px" ,   
}}>/</span>

  <span style={{ letterSpacing: "0.35px", 
 }}>USA</span>

  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    marginLeft: "2.3px",
    letterSpacing:0.45,
    fontSize: "8.2px",        // Keep consistent base font size

  }}>
    {usaValue}
  </span>

</span>
    
        </div>
        <div style={{ border:"1px solid transparent", position:"absolute", left:2.5, top:"35px", width:"93.2%", display:"flex", justifyContent:"center",zIndex:2,alignItems:"center",    transform: "translateY(0.5px)" 
 }}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#b2b5b4",
    fontSize: "7.5px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text
  }}
>
  <span style={{ letterSpacing: "0.35px",
 }}>MEX</span>
  

  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    marginLeft: "2.3px",
    letterSpacing:0.45,
    fontSize: "8.2px",        // Keep consistent base font size

  }}>
    {mexValue}
  </span>

</span>
    
        </div>
        </>
      )}
      {usaValue !== eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0,top:"18.9px", width:"84.7%", display:"flex", justifyContent:"flex-end",zIndex:2,alignItems:"center"}}>
        <span
               className='HelveticaNeueLT57Condensed'
    style={{
      color: "#b2b5b4",
      fontSize: "7.5px",
      // İsterseniz letterSpacing veya wordSpacing'i buradan da verebilirsiniz
      // letterSpacing: 0.48,
      // wordSpacing: "2px",
    }}
  >
    {/* EUR */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        // marginTop: .1 --> inline-block'ta biraz yukarı boşluk yaratabilir
      }}
    >
      EUR
    </span>

    {/* EUR Value */}
    <span
      className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      {eurValue}
    </span>

    {/* USA */}
    <span
    
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      USA
    </span>

    {/* USA Value (Bold) */}
    <span

    className='HelveticaNeueLT77BoldCondensed'
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        fontWeight: 600,
      }}
    >
      {usaValue}
    </span>

    {/* MEX */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      MEX
    </span>

    {/* MEX Value (Bold, different letterSpacing) */}
    <span
        className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.8,
        fontWeight: 600,
      }}
    >
      {mexValue}
    </span>
  </span>
        </div>
   
      )}
      {category === "Kids" && (
        <>
        <div style={{ border:"1px solid transparent", position:"absolute", left:2.5, top:"27.4px", width:"93.2%", display:"flex", justifyContent:"center",zIndex:2,alignItems:"center",    transform: "translateY(0.5px)" 
 }}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#b2b5b4",
    fontSize: "7.5px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text
  }}
>
  <span style={{ letterSpacing: "0.35px",
 }}>{filteredIndo[inx]?.name}</span>
  
  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    marginLeft: "2.3px",
    letterSpacing:0.45,
    fontSize: "8.2px",        // Keep consistent base font size

  }}>
    {filteredIndo[inx]?.isMonth}
  </span>

</span>
    
        </div>
        <div style={{ border:"1px solid transparent", position:"absolute", left:2.5, top:"35px", width:"93.2%", display:"flex", justifyContent:"center",zIndex:2,alignItems:"center",    transform: "translateY(0.5px)" 
 }}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#b2b5b4",
    fontSize: "7.5px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text
  }}
>
  <span style={{ letterSpacing: "0.35px",
 }}>{filteredIndo[inx]?.cm?.slice(0, 3)}</span>
  

  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    marginLeft: "2.3px",
    letterSpacing:0.45,
    fontSize: "8.2px",        // Keep consistent base font size

  }}>
    CM
  </span>

</span>
    
        </div>
        </>
      )}
      
      {/* MADE IN Kısmı */}
      <div
  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 2,
    top: "45.7px",
  
  width:"94.7%",
    display: "flex",
    justifyContent: "center",
    flexDirection:"column",

    zIndex:2,
    transform: "translateY(0.5px)"
  }}
>      
<span   className='HelveticaNeueLT57Condensed' style={{ color:"#b2b5b4", fontSize:"7.6px", letterSpacing:0.34, marginTop:.1 }}>

          MADE IN
        </span>
      

      </div>

      <div
  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 2,
    top: "53.7px",
  
  width:"95%",
    display: "flex",
    justifyContent: "center",
    flexDirection:"column",

    zIndex:2,
    transform: "translateY(0.5px)"
  }}
>    

<span   className='HelveticaNeueLT57Condensed' style={{ color:"#b2b5b4", fontSize:"7.6px", letterSpacing:0.34, marginTop:.1 }}>
        {CountryName}
        </span>
    </div>
    </div>
  );
};



const WPZCALL006 = ({currentShape, category, referance, CountryName, filteredIndo, inx, szrgrp, valueBasedOnInx,CardBackBack}) => {
  const [TopValue, setTopValue] = useState("27px")

  // Gelen değerleri konsolda görmek için:
  console.log("USA Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.usa);
  console.log("EUR Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.europe);
  const usaValue = szrgrp?.sizes?.[valueBasedOnInx]?.usa;
  const eurValue =szrgrp?.sizes?.[valueBasedOnInx]?.europe;
  const mexValue =szrgrp?.sizes?.[valueBasedOnInx]?.mexico;
  console.log("refrefgeldi",referance)

  useEffect(() => {
    if (
      referance?.linecount === inx || // linecount, inx'e eşitse
      referance?.linecount === 0 || // linecount 0 ise
      (referance?.linecount !== 0 && inx % referance?.linecount === 0) // linecount 0 değilse ve inx'in katıysa
    ) {
      setTopValue("27.1px");
    } else {
      setTopValue("27px");

    }
  }, [referance, inx]); // 👈 Bağımlılıklar (referance veya inx değiştiğinde çalışır)
  return (
    <div style={{ position:"relative", width:"100%", minHeight:`${referance.height+2.5}mm` }}>
       {CardBackBack ? (
    <div 
      style={{
        position: "absolute", 
        top: `0`, // Her öğe için 5% fark ekleyerek aşağı kaydırıyoruz
    left: "0",

      }}
    >
      {(() => {
        const referenceCode = referance?.code;
        const referenceWidth = referance?.width;
        let width = `${referenceWidth}mm`;
        let height = "auto";

        return typeof CardBackBack === "function" ? (
          <CardBackBack width={width} height={height} />
        ) : (
          <img src={CardBackBack} alt="SVG Image" style={{ width, height }} />
        );
      })()}
    </div>
  ) : (
    <span>Loading...</span>
  )}
      <div style={{ position:"absolute", right:"23px", top:"75.5px" }}>
        {renderShape(currentShape, category,"#7c7d7f")}
      </div>

      {/* Şart: USA ile EUR eşitse bu bloğu döndür */}
      
      {usaValue === eurValue && category !== "Kids" && (
        <>
        <div style={{ border:"1px solid transparent", position:"absolute", left:1.4, top:"24.2px", width:"96%", display:"flex", justifyContent:"center",zIndex:2,alignItems:"center",    transform: "translateY(0.7px)" 
 }}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#b2b5b4",
    fontSize: "7.5px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text
  }}
>
  <span style={{ letterSpacing: "0.25px",
 }}>EUR</span>
  
  <span >/</span>

  <span style={{ letterSpacing: "0.3px", marginRight:0.2,marginLeft:0.35 
 }}>USA</span>

  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    marginLeft: "1.7px",
    letterSpacing:0.35,
    fontSize: "8.2px",        // Keep consistent base font size

  }}>
    {usaValue}
  </span>

</span>
    
        </div>
        <div style={{ border:"1px solid transparent", position:"absolute", left:1.4, top:"32px", width:"96%", display:"flex", justifyContent:"center",zIndex:2,alignItems:"center",    transform: "translateY(0.7px)" 
 }}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#b2b5b4",
    fontSize: "7.5px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text

  }}
>
  <span style={{ letterSpacing: "0.25px",
 }}>MEX</span>
  

  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    marginLeft: "1.9px",
    letterSpacing:0.35,
    fontSize: "8.2px",        // Keep consistent base font size


  }}>
    {mexValue}
  </span>

</span>
    
        </div>
        </>
      )}
      {usaValue !== eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0,top:"18.9px", width:"84.7%", display:"flex", justifyContent:"flex-end",zIndex:2,alignItems:"center"}}>
        <span
               className='HelveticaNeueLT57Condensed'
    style={{
      color: "#b2b5b4",
      fontSize: "7.5px",
      // İsterseniz letterSpacing veya wordSpacing'i buradan da verebilirsiniz
      // letterSpacing: 0.48,
      // wordSpacing: "2px",
    }}
  >
    {/* EUR */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        // marginTop: .1 --> inline-block'ta biraz yukarı boşluk yaratabilir
      }}
    >
      EUR
    </span>

    {/* EUR Value */}
    <span
      className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      {eurValue}
    </span>

    {/* USA */}
    <span
    
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      USA
    </span>

    {/* USA Value (Bold) */}
    <span

    className='HelveticaNeueLT77BoldCondensed'
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        fontWeight: 600,
      }}
    >
      {usaValue}
    </span>

    {/* MEX */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      MEX
    </span>

    {/* MEX Value (Bold, different letterSpacing) */}
    <span
        className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.8,
        fontWeight: 600,
      }}
    >
      {mexValue}
    </span>
  </span>
        </div>
   
      )}
      {category === "Kids" && (
        <>
        <div style={{ border:"1px solid transparent", position:"absolute", left:1.4, top:"24.2px", width:"96%", display:"flex", justifyContent:"center",zIndex:2,alignItems:"center",    transform: "translateY(0.7px)" 
 }}>
      <span
  className='HelveticaNeueLT77BoldCondensed'
  style={{
    color: "#b2b5b4",
    fontSize: "7.5px",
    display: 'inline-flex',         // Flex container
    alignItems: 'flex-start',       // Tüm elemanları top'a hizala
    lineHeight: '8.7px',
    transform: "translateY(-0.5px)" // Gerekirse hassas ayar
  }}
>
  <span style={{ letterSpacing: "0.25px" }}>
    {filteredIndo[inx]?.name}
  </span>
  
  <span
    className='HelveticaNeueLT57Condensed'
    style={{
      marginLeft: "2.3px",
      letterSpacing: 0.35,
      fontSize: "8.2px",
      fontWeight: 300,
    }}
  >
    {filteredIndo[inx]?.isMonth}
  </span>
</span>

        </div>
        <div style={{
  border: "1px solid transparent",
  position: "absolute",
  left: 1.4,
  top: "32px",
  width: "96%",
  display: "flex",
  justifyContent: "center",
  zIndex: 2,
  alignItems: "center",
  transform: "translateY(0.7px)"
}}>
  <span
    className='HelveticaNeueLT77BoldCondensed'
    style={{
      color: "#b2b5b4",
      fontSize: "7.5px",
      display: 'inline-flex',      // Flex container
      alignItems: 'flex-start',    // Tüm içeriği yukarı hizala
      lineHeight: '8.2px',
    }}
  >
    <span style={{ letterSpacing: "0.25px" }}>
      {filteredIndo[inx]?.cm?.slice(0, 3)}
    </span>

    <span
      className='HelveticaNeueLT57Condensed'
      style={{
        marginLeft: "2.3px",
        letterSpacing: 0.35,
        fontSize: "8.2px",
        fontWeight: 300,
      }}
    >
      CM
    </span>
  </span>
</div>

        </>
      )}
      
      {/* MADE IN Kısmı */}
      <div
  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 1,
    top: "40.5px",
  
  width:"97.7%",
    display: "flex",
    justifyContent: "center",
    flexDirection:"column",

    zIndex:2,
    transform: "translateY(0.5px)"
  }}
>      
<span   className='HelveticaNeueLT57Condensed' style={{ color:"#b2b5b4", fontSize:"7.6px",fontWeight:300, letterSpacing:0.25, marginTop:.1,wordSpacing:0 }}>

          MADE IN
        </span>
      

      </div>

      <div
  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 1.3,
    top: "48.3px",
  
  width:"95.7%",
    display: "flex",
    justifyContent: "center",
    flexDirection:"column",

    zIndex:2,
    transform: "translateY(1px)"
  }}
>    

<span   className='HelveticaNeueLT57Condensed' style={{ color:"#b2b5b4", fontSize:"7.6px", fontWeight:300, letterSpacing:0.25, marginTop:.1 }}>
        {CountryName}
        </span>
    </div>
    </div>
  );
};


const WPZCALL007 = ({currentShape, category, referance, CountryName, filteredIndo, inx, szrgrp, valueBasedOnInx,CardBackBack}) => {
  const [TopValue, setTopValue] = useState("27px")

  // Gelen değerleri konsolda görmek için:
  console.log("USA Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.usa);
  console.log("EUR Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.europe);
  const usaValue = szrgrp?.sizes?.[valueBasedOnInx]?.usa;
  const eurValue =szrgrp?.sizes?.[valueBasedOnInx]?.europe;
  const mexValue =szrgrp?.sizes?.[valueBasedOnInx]?.mexico;
  console.log("refrefgeldi",referance)

  useEffect(() => {
    if (
      referance?.linecount === inx || // linecount, inx'e eşitse
      referance?.linecount === 0 || // linecount 0 ise
      (referance?.linecount !== 0 && inx % referance?.linecount === 0) // linecount 0 değilse ve inx'in katıysa
    ) {
      setTopValue("27.1px");
    } else {
      setTopValue("27px");

    }
  }, [referance, inx]); // 👈 Bağımlılıklar (referance veya inx değiştiğinde çalışır)
  return (
    <div style={{ position:"relative", width:"100%", minHeight:`${referance.height}mm` }}>
       {CardBackBack ? (
    <div 
      style={{
        position: "absolute", 
        top: `0`, // Her öğe için 5% fark ekleyerek aşağı kaydırıyoruz
    left: "0",

      }}
    >
      {(() => {
        const referenceCode = referance?.code;
        const referenceWidth = referance?.width;
        let width = `${referenceWidth}mm`;
        let height = "auto";

        return typeof CardBackBack === "function" ? (
          <CardBackBack width={width} height={height} />
        ) : (
          <img src={CardBackBack} alt="SVG Image" style={{ width, height }} />
        );
      })()}
    </div>
  ) : (
    <span>Loading...</span>
  )}
      <div style={{ position:"absolute", right:"58px", bottom:"132.1px" }}>
      {renderShape(currentShape, category, "#b1b4b3")}
      </div>

      {/* Şart: USA ile EUR eşitse bu bloğu döndür */}
      
      {usaValue === eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top: "36%", width:"94.4%",marginLeft:4, display:"flex", justifyContent:"center",zIndex:2,    transform: "translateX(0.4px)" 
 }}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#7d7d7f",
    fontSize: "7.7px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text
  }}
>
  <span style={{ letterSpacing: "0.3px",
 }}>EUR</span>
  
  <span style={{ margin: "0 0.4px" ,   
}}>/</span>

  <span style={{ letterSpacing: "0.4px", 
 }}>USA</span>

  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{

    fontWeight: 900,
    marginLeft:"2.2px",
    fontSize: "8.2px",        // Keep consistent base font size

  }}>
    {usaValue}
  </span>

  <span style={{
        marginLeft:"5px",

    letterSpacing: "0.4px",

  }}>
    MEX
  </span>

  <span 
  
  className='HelveticaNeueLT77BoldCondensed'

  style={{
    marginLeft:"2.2px",

    fontWeight: 900,
    letterSpacing: "0.5px",
    fontSize: "8.2px",        // Keep consistent base font size


  }}>
    {mexValue}
  </span>
</span>

        </div>
      )}
      {usaValue !== eurValue && category !== "Kids" && (
        <div
style={{ border:"1px solid transparent", position:"absolute", left:0, top: "36%", width:"94.4%",marginLeft:4, display:"flex", justifyContent:"center",zIndex:2,    transform: "translateX(0.4px)" 
 }}
>
  {/* Tek bir ebeveyn span */}
  <span
               className='HelveticaNeueLT57Condensed'
    style={{
      color: "#7d7d7f",
      fontSize: "7.7px",
      // İsterseniz letterSpacing veya wordSpacing'i buradan da verebilirsiniz
      // letterSpacing: 0.48,
      // wordSpacing: "2px",
    }}
  >
    {/* EUR */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        // marginTop: .1 --> inline-block'ta biraz yukarı boşluk yaratabilir
      }}
    >
      EUR
    </span>

    {/* EUR Value */}
    <span
      className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      {eurValue}
    </span>

    {/* USA */}
    <span
    
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      USA
    </span>

    {/* USA Value (Bold) */}
    <span

    className='HelveticaNeueLT77BoldCondensed'
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        fontWeight: 600,
        fontSize: "8.2px",        // Keep consistent base font size

      }}
    >
      {usaValue}
    </span>

    {/* MEX */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      MEX
    </span>

    {/* MEX Value (Bold, different letterSpacing) */}
    <span
        className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.8,
        fontWeight: 600,
        fontSize: "8.2px",        // Keep consistent base font size

      }}
    >
      {mexValue}
    </span>
  </span>
</div>

      )}
      {category === "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top: "36%", width:"94.4%",marginLeft:4, display:"flex", justifyContent:"center",zIndex:2,    transform: "translateX(0.4px)" 
 }}>
        <span
               className='HelveticaNeueLT57Condensed'
  style={{
    color: "#7d7d7f",
    fontSize: "7.7px",
    // Tek bir yerde letterSpacing ya da wordSpacing verebilirsiniz
    // letterSpacing: 0.48,
  }}
>
  {/* filteredIndo[inx]?.name */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontSize: "8.2px",        // Keep consistent base font size

    }}
  >
    {filteredIndo[inx]?.name}
  </span>

  {/* 'MONTH' / 'YEARS' */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    {filteredIndo[inx]?.isMonth}
  </span>

  {/* filteredIndo[inx]?.cm?.slice(0, 3) */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontSize: "8.2px",        // Keep consistent base font size

    }}
  >
    {filteredIndo[inx]?.cm?.slice(0, 3)}
  </span>

  {/* "CM" */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    CM
  </span>
</span>

        </div>
      )}
      
      {/* MADE IN Kısmı */}
      <div

  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 0,
    marginLeft:4.4,
    top: "134px",
    width:"94.4%",
    display: "flex",
    justifyContent: "center",
    zIndex:2,
    transform: "translateY(0.9px)" 

  }}
>        <span  className='HelveticaNeueLT57Condensed' style={{ color:"#7d7d7f", fontSize:"7.7px", letterSpacing:0.45 }}>
          MADE IN {CountryName}
        </span>
      </div>
    </div>
  );
};

const WPZCALL008 = ({currentShape, category, referance, CountryName, filteredIndo, inx, szrgrp, valueBasedOnInx,CardBackBack}) => {
  const [TopValue, setTopValue] = useState("27px")

  // Gelen değerleri konsolda görmek için:
  console.log("USA Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.usa);
  console.log("EUR Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.europe);
  const usaValue = szrgrp?.sizes?.[valueBasedOnInx]?.usa;
  const eurValue =szrgrp?.sizes?.[valueBasedOnInx]?.europe;
  const mexValue =szrgrp?.sizes?.[valueBasedOnInx]?.mexico;
  console.log("refrefgeldi",referance)

  useEffect(() => {
    if (
      referance?.linecount === inx || // linecount, inx'e eşitse
      referance?.linecount === 0 || // linecount 0 ise
      (referance?.linecount !== 0 && inx % referance?.linecount === 0) // linecount 0 değilse ve inx'in katıysa
    ) {
      setTopValue("27.1px");
    } else {
      setTopValue("27px");

    }
  }, [referance, inx]); // 👈 Bağımlılıklar (referance veya inx değiştiğinde çalışır)
  return (
    <div style={{ position:"relative", width:"100%", minHeight:`${referance.height+2.5}mm` }}>
       {CardBackBack ? (
    <div 
      style={{
        position: "absolute", 
        top: `0`, // Her öğe için 5% fark ekleyerek aşağı kaydırıyoruz
    left: "0",

      }}
    >
      {(() => {
        const referenceCode = referance?.code;
        const referenceWidth = referance?.width;
        let width = `${referenceWidth}mm`;
        let height = "auto";

        return typeof CardBackBack === "function" ? (
          <CardBackBack width={width} height={height} />
        ) : (
          <img src={CardBackBack} alt="SVG Image" style={{ width, height }} />
        );
      })()}
    </div>
  ) : (
    <span>Loading...</span>
  )}


      {/* Şart: USA ile EUR eşitse bu bloğu döndür */}
      
      {usaValue === eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top: "33.2%", width:"83.75%", display:"flex", justifyContent:"flex-end",zIndex:2,    transform: "translateY(0.2px)" 
}}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#7d7d7f",
    fontSize: "7.3px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text
  }}
>
  <span style={{ letterSpacing: "0.35px",
 }}>EUR</span>
  
  <span style={{ margin: "0 0.4px" ,   
}}>/</span>

  <span style={{ letterSpacing: "0.5px", marginLeft:"0.2px"
 }}>USA</span>

  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{

    fontWeight: 900,
    marginLeft:"2px",
    fontSize: "8px",        // Keep consistent base font size

  }}>
    {usaValue}
  </span>

  <span style={{
        marginLeft:"5.2px",

    letterSpacing: "0.4px",

  }}>
    MEX
  </span>

  <span 
  
  className='HelveticaNeueLT77BoldCondensed'

  style={{
    marginLeft:"2.1px",

    fontWeight: 900,
    letterSpacing: "0.45px",
    fontSize: "8px",        // Keep consistent base font size


  }}>
    {mexValue}
  </span>
</span>


        </div>
      )}
      {usaValue !== eurValue && category !== "Kids" && (
        <div
               className='HelveticaNeueLT57Condensed'

  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 0,
    top: "33.2%",
    width:"83.75%",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    zIndex: 2,
  }}
>
  {/* Tek bir ebeveyn span */}
  <span
               className='HelveticaNeueLT57Condensed'
    style={{
      color: "#7d7d7f",
      fontSize: "7.3px",
      // İsterseniz letterSpacing veya wordSpacing'i buradan da verebilirsiniz
      // letterSpacing: 0.48,
      // wordSpacing: "2px",
    }}
  >
    {/* EUR */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        // marginTop: .1 --> inline-block'ta biraz yukarı boşluk yaratabilir
      }}
    >
      EUR
    </span>

    {/* EUR Value */}
    <span
      className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      {eurValue}
    </span>

    {/* USA */}
    <span
    
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      USA
    </span>

    {/* USA Value (Bold) */}
    <span

    className='HelveticaNeueLT77BoldCondensed'
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        fontWeight: 600,
      }}
    >
      {usaValue}
    </span>

    {/* MEX */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      MEX
    </span>

    {/* MEX Value (Bold, different letterSpacing) */}
    <span
        className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.8,
        fontWeight: 600,
      }}
    >
      {mexValue}
    </span>
  </span>
</div>

      )}
      {category === "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top: "33.2%", width:"83.75%", display:"flex", justifyContent:"flex-end",zIndex:2 }}>
        <span
               className='HelveticaNeueLT57Condensed'
  style={{
    color: "#7d7d7f",
    fontSize: "7.3px",
    // Tek bir yerde letterSpacing ya da wordSpacing verebilirsiniz
    // letterSpacing: 0.48,
  }}
>
  {/* filteredIndo[inx]?.name */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
    }}
  >
    {filteredIndo[inx]?.name}
  </span>

  {/* 'MONTH' / 'YEARS' */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    {filteredIndo[inx]?.isMonth}
  </span>

  {/* filteredIndo[inx]?.cm?.slice(0, 3) */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
    }}
  >
    {filteredIndo[inx]?.cm?.slice(0, 3)}
  </span>

  {/* "CM" */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    CM
  </span>
</span>

        </div>
      )}
      
      {/* MADE IN Kısmı */}
      <div

  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 0,
    top: "29.5px",
    width:"83.77%",
    display: "flex",
    justifyContent: "flex-end",
    zIndex:2,
    transform: "translateY(0.6px)" 

  }}
>        <span  className='HelveticaNeueLT57Condensed' style={{ color:"#7d7d7f", fontSize:"7.3px", letterSpacing:0.53 }}>
          MADE IN {CountryName}
        </span>
      </div>
    </div>
  );
};

const WPZCALL009 = ({currentShape, category, referance, CountryName, filteredIndo, inx, szrgrp, valueBasedOnInx,CardBackBack}) => {
  const [TopValue, setTopValue] = useState("27px")

  // Gelen değerleri konsolda görmek için:
  console.log("USA Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.usa);
  console.log("EUR Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.europe);
  const usaValue = szrgrp?.sizes?.[valueBasedOnInx]?.usa;
  const eurValue =szrgrp?.sizes?.[valueBasedOnInx]?.europe;
  const mexValue =szrgrp?.sizes?.[valueBasedOnInx]?.mexico;
  console.log("refrefgeldi",referance)

  useEffect(() => {
    if (
      referance?.linecount === inx || // linecount, inx'e eşitse
      referance?.linecount === 0 || // linecount 0 ise
      (referance?.linecount !== 0 && inx % referance?.linecount === 0) // linecount 0 değilse ve inx'in katıysa
    ) {
      setTopValue("27.1px");
    } else {
      setTopValue("27px");

    }
  }, [referance, inx]); // 👈 Bağımlılıklar (referance veya inx değiştiğinde çalışır)
  return (
    <div style={{ position:"relative", width:"100%", minHeight:`${referance.height+2.5}mm` }}>
       {CardBackBack ? (
    <div 
      style={{
        position: "absolute", 
        top: `0`, // Her öğe için 5% fark ekleyerek aşağı kaydırıyoruz
    left: "0",

      }}
    >
      {(() => {
        const referenceCode = referance?.code;
        const referenceWidth = referance?.width;
        let width = `${referenceWidth}mm`;
        let height = "auto";

        return typeof CardBackBack === "function" ? (
          <CardBackBack width={width} height={height} />
        ) : (
          <img src={CardBackBack} alt="SVG Image" style={{ width, height }} />
        );
      })()}
    </div>
  ) : (
    <span>Loading...</span>
  )}
      <div style={{ position:"absolute", right:"12.83px", top:"21.5px" }}>
        {renderShape(currentShape, category,"#7d7d7f")}
      </div>

      {/* Şart: USA ile EUR eşitse bu bloğu döndür */}
      
      {usaValue === eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top:"18.9px", width:"84.7%", display:"flex", justifyContent:"flex-end",zIndex:2,alignItems:"center",    transform: "translateY(0.5px)" 
 }}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#7d7d7f",
    fontSize: "8px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text
  }}
>
  <span style={{ letterSpacing: "0.35px",
 }}>EUR</span>
  
  <span style={{ margin: "0 0.4px" ,   
}}>/</span>

  <span style={{ letterSpacing: "0.4px", 
 }}>USA</span>

  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    marginLeft: "2.6px",
    fontSize: "8.5px",        // Keep consistent base font size

  }}>
    {usaValue}
  </span>

  <span style={{
    marginLeft: "5.6px",
    letterSpacing: "0.4px",

  }}>
    MEX
  </span>

  <span 
  
  className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    letterSpacing: "0.8px",
    marginLeft: "2.5px",
    fontSize: "8.5px",        // Keep consistent base font size


  }}>
    {mexValue}
  </span>
</span>

        </div>
      )}
      {usaValue !== eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0,top:"18.9px", width:"84.7%", display:"flex", justifyContent:"flex-end",zIndex:2,alignItems:"center"}}>
        <span
               className='HelveticaNeueLT57Condensed'
    style={{
      color: "#7d7d7f",
      fontSize: "8px",
      // İsterseniz letterSpacing veya wordSpacing'i buradan da verebilirsiniz
      // letterSpacing: 0.48,
      // wordSpacing: "2px",
    }}
  >
    {/* EUR */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        // marginTop: .1 --> inline-block'ta biraz yukarı boşluk yaratabilir
      }}
    >
      EUR
    </span>

    {/* EUR Value */}
    <span
      className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      {eurValue}
    </span>

    {/* USA */}
    <span
    
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      USA
    </span>

    {/* USA Value (Bold) */}
    <span

    className='HelveticaNeueLT77BoldCondensed'
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        fontWeight: 600,
      }}
    >
      {usaValue}
    </span>

    {/* MEX */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      MEX
    </span>

    {/* MEX Value (Bold, different letterSpacing) */}
    <span
        className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.8,
        fontWeight: 600,
      }}
    >
      {mexValue}
    </span>
  </span>
        </div>
      )}
      {category === "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top:"18.9px", width:"84.7%",display:"flex", justifyContent:"flex-end",zIndex:2 }}>
        <span
               className='HelveticaNeueLT57Condensed'
  style={{
    color: "#7d7d7f",
    fontSize: "8px",
    // Tek bir yerde letterSpacing ya da wordSpacing verebilirsiniz
    // letterSpacing: 0.48,
  }}
>
  {/* filteredIndo[inx]?.name */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      marginTop: 0.1, 
    }}
  >
    {filteredIndo[inx]?.name}
  </span>

  {/* 'MONTH' / 'YEARS' */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    {filteredIndo[inx]?.isMonth}
  </span>

  {/* filteredIndo[inx]?.cm?.slice(0, 3) */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      marginTop: 0.1, 
    }}
  >
    {filteredIndo[inx]?.cm?.slice(0, 3)}
  </span>

  {/* "CM" */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    CM
  </span>
</span>
        </div>
      )}
      
      {/* MADE IN Kısmı */}
      <div
  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 0,
    top: "27.3px",
  
  width:"84.4%",
    display: "flex",
    justifyContent: "flex-end",
    zIndex:2,
    transform: "translateY(0.3px)"
  }}
>        <span   className='HelveticaNeueLT57Condensed' style={{ color:"#7d7d7f", fontSize:"8px", letterSpacing:0.48, marginTop:.1 }}>
          MADE IN {CountryName}
        </span>
      </div>
    </div>
  );
};

const WPZCALL010 = ({currentShape, category, referance, CountryName, filteredIndo, inx, szrgrp, valueBasedOnInx,CardBackBack}) => {
  const [TopValue, setTopValue] = useState("27px")

  // Gelen değerleri konsolda görmek için:
  console.log("USA Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.usa);
  console.log("EUR Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.europe);
  const usaValue = szrgrp?.sizes?.[valueBasedOnInx]?.usa;
  const eurValue =szrgrp?.sizes?.[valueBasedOnInx]?.europe;
  const mexValue =szrgrp?.sizes?.[valueBasedOnInx]?.mexico;
  console.log("refrefgeldi",referance)

  useEffect(() => {
    if (
      referance?.linecount === inx || // linecount, inx'e eşitse
      referance?.linecount === 0 || // linecount 0 ise
      (referance?.linecount !== 0 && inx % referance?.linecount === 0) // linecount 0 değilse ve inx'in katıysa
    ) {
      setTopValue("27.1px");
    } else {
      setTopValue("27px");

    }
  }, [referance, inx]); // 👈 Bağımlılıklar (referance veya inx değiştiğinde çalışır)
  return (
    <div style={{ position:"relative", width:"100%", minHeight:`${referance.height+2.5}mm` }}>
       {CardBackBack ? (
    <div 
      style={{
        position: "absolute", 
        top: `0`, // Her öğe için 5% fark ekleyerek aşağı kaydırıyoruz
    left: "0",

      }}
    >
      {(() => {
        const referenceCode = referance?.code;
        const referenceWidth = referance?.width;
        let width = `${referenceWidth}mm`;
        let height = "auto";

        return typeof CardBackBack === "function" ? (
          <CardBackBack width={width} height={height} />
        ) : (
          <img src={CardBackBack} alt="SVG Image" style={{ width, height }} />
        );
      })()}
    </div>
  ) : (
    <span>Loading...</span>
  )}
      <div style={{ position:"absolute", right:"30.83px", top:"37px" }}>
        {renderShape(currentShape, category,"#7d7d7f")}
      </div>

      {/* Şart: USA ile EUR eşitse bu bloğu döndür */}
      
      {usaValue === eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top:"34.7px", width:"76.7%", display:"flex", justifyContent:"flex-end",zIndex:2,alignItems:"center",    transform: "translateY(0.5px)" 
 }}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#7d7d7f",
    fontSize: "7.5px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text
  }}
>
  <span style={{ 
 }}>EUR</span>
  
  <span style={{ margin: "0 0.3px" ,   
}}>/</span>

  <span style={{ 
 }}>USA</span>

  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    marginLeft: "2.2px",
    fontSize: "8px",        // Keep consistent base font size

  }}>
    {usaValue}
  </span>

  <span style={{
    marginLeft: "4.3px",
 

  }}>
    MEX
  </span>

  <span 
  
  className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,

    marginLeft: "2.5px",
    fontSize: "8px",        // Keep consistent base font size


  }}>
    {mexValue}
  </span>
</span>

        </div>
      )}
      {usaValue !== eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top:"34.7px", width:"76.7%", display:"flex", justifyContent:"flex-end",zIndex:2,alignItems:"center"}}>
        <span
               className='HelveticaNeueLT57Condensed'
    style={{
      color: "#7d7d7f",
      fontSize: "7.5px",
      // İsterseniz letterSpacing veya wordSpacing'i buradan da verebilirsiniz
      // letterSpacing: 0.48,
      // wordSpacing: "2px",
    }}
  >
    {/* EUR */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        // marginTop: .1 --> inline-block'ta biraz yukarı boşluk yaratabilir
      }}
    >
      EUR
    </span>

    {/* EUR Value */}
    <span
      className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
      }}
    >
      {eurValue}
    </span>

    {/* USA */}
    <span
    
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      USA
    </span>

    {/* USA Value (Bold) */}
    <span

    className='HelveticaNeueLT77BoldCondensed'
      style={{
        display: "inline-block",
        marginLeft: 2,
        fontWeight: 600,
      }}
    >
      {usaValue}
    </span>

    {/* MEX */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
      }}
    >
      MEX
    </span>

    {/* MEX Value (Bold, different letterSpacing) */}
    <span
        className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        fontWeight: 600,
      }}
    >
      {mexValue}
    </span>
  </span>
        </div>
      )}
      {category === "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0,  top:"34.7px", width:"76.7%",display:"flex", justifyContent:"flex-end",zIndex:2 }}>
        <span
               className='HelveticaNeueLT57Condensed'
  style={{
    color: "#7d7d7f",
    fontSize: "7.5px",
    // Tek bir yerde letterSpacing ya da wordSpacing verebilirsiniz
    // letterSpacing: 0.48,
  }}
>
  {/* filteredIndo[inx]?.name */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      marginTop: 0.1, 
    }}
  >
    {filteredIndo[inx]?.name}
  </span>

  {/* 'MONTH' / 'YEARS' */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      fontWeight: 600,
    }}
  >
    {filteredIndo[inx]?.isMonth}
  </span>

  {/* filteredIndo[inx]?.cm?.slice(0, 3) */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      marginTop: 0.1, 
    }}
  >
    {filteredIndo[inx]?.cm?.slice(0, 3)}
  </span>

  {/* "CM" */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      fontWeight: 600,
    }}
  >
    CM
  </span>
</span>
        </div>
      )}
      
      {/* MADE IN Kısmı */}
      <div
  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 0,
    top: "42.9px",
 width:"76.7%",

    display: "flex",
    justifyContent: "flex-end",
    zIndex:2,
    transform: "translateY(0.3px)"
  }}
>        <span   className='HelveticaNeueLT57Condensed' style={{ color:"#7d7d7f", fontSize: "7.4px", marginTop:.1 ,letterSpacing:"0.15px"}}>
          MADE IN {CountryName}
        </span>
      </div>
    </div>
  );
};
const WPZCALL011 = ({currentShape, category, referance, CountryName, filteredIndo, inx, szrgrp, valueBasedOnInx,CardBackBack}) => {
  const [TopValue, setTopValue] = useState("27px")

  // Gelen değerleri konsolda görmek için:
  console.log("USA Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.usa);
  console.log("EUR Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.europe);
  const usaValue = szrgrp?.sizes?.[valueBasedOnInx]?.usa;
  const eurValue =szrgrp?.sizes?.[valueBasedOnInx]?.europe;
  const mexValue =szrgrp?.sizes?.[valueBasedOnInx]?.mexico;
  console.log("refrefgeldi",referance)

  useEffect(() => {
    if (
      referance?.linecount === inx || // linecount, inx'e eşitse
      referance?.linecount === 0 || // linecount 0 ise
      (referance?.linecount !== 0 && inx % referance?.linecount === 0) // linecount 0 değilse ve inx'in katıysa
    ) {
      setTopValue("27.1px");
    } else {
      setTopValue("27px");

    }
  }, [referance, inx]); // 👈 Bağımlılıklar (referance veya inx değiştiğinde çalışır)
  return (
    <div style={{ position:"relative", width:"100%", minHeight:`${referance.height+2.5}mm` }}>
       {CardBackBack ? (
    <div 
      style={{
        position: "absolute", 
        top: `0`, // Her öğe için 5% fark ekleyerek aşağı kaydırıyoruz
    left: "0",

      }}
    >
      {(() => {
        const referenceCode = referance?.code;
        const referenceWidth = referance?.width;
        let width = `${referenceWidth}mm`;
        let height = "auto";

        return typeof CardBackBack === "function" ? (
          <CardBackBack width={width} height={height} />
        ) : (
          <img src={CardBackBack} alt="SVG Image" style={{ width, height }} />
        );
      })()}
    </div>
  ) : (
    <span>Loading...</span>
  )}
      <div style={{ position:"absolute", right:"28.83px", top:"84.5px" }}>
        {renderShape(currentShape, category,"#7d7d7f")}
      </div>

      {/* Şart: USA ile EUR eşitse bu bloğu döndür */}
      
      {usaValue === eurValue && category !== "Kids" && (
        <>
        <div style={{ border:"1px solid transparent", position:"absolute", left:2.5, top:"27.4px", width:"93.2%", display:"flex", justifyContent:"center",zIndex:2,alignItems:"center",    transform: "translateY(0.5px)" 
 }}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#7d7d7f",
    fontSize: "7.5px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text
  }}
>
  <span style={{ letterSpacing: "0.35px",
 }}>EUR</span>
  
  <span style={{ margin: "0 0.35px" ,   
}}>/</span>

  <span style={{ letterSpacing: "0.35px", 
 }}>USA</span>

  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    marginLeft: "2.3px",
    letterSpacing:0.45,
    fontSize: "8.2px",        // Keep consistent base font size

  }}>
    {usaValue}
  </span>

</span>
    
        </div>
        <div style={{ border:"1px solid transparent", position:"absolute", left:2.5, top:"35px", width:"93.2%", display:"flex", justifyContent:"center",zIndex:2,alignItems:"center",    transform: "translateY(0.5px)" 
 }}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#7d7d7f",
    fontSize: "7.5px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text
  }}
>
  <span style={{ letterSpacing: "0.35px",
 }}>MEX</span>
  

  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    marginLeft: "2.3px",
    letterSpacing:0.45,
    fontSize: "8.2px",        // Keep consistent base font size

  }}>
    {mexValue}
  </span>

</span>
    
        </div>
        </>
      )}
      {usaValue !== eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0,top:"18.9px", width:"84.7%", display:"flex", justifyContent:"flex-end",zIndex:2,alignItems:"center"}}>
        <span
               className='HelveticaNeueLT57Condensed'
    style={{
      color: "#7d7d7f",
      fontSize: "7.5px",
      // İsterseniz letterSpacing veya wordSpacing'i buradan da verebilirsiniz
      // letterSpacing: 0.48,
      // wordSpacing: "2px",
    }}
  >
    {/* EUR */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        // marginTop: .1 --> inline-block'ta biraz yukarı boşluk yaratabilir
      }}
    >
      EUR
    </span>

    {/* EUR Value */}
    <span
      className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      {eurValue}
    </span>

    {/* USA */}
    <span
    
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      USA
    </span>

    {/* USA Value (Bold) */}
    <span

    className='HelveticaNeueLT77BoldCondensed'
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        fontWeight: 600,
      }}
    >
      {usaValue}
    </span>

    {/* MEX */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      MEX
    </span>

    {/* MEX Value (Bold, different letterSpacing) */}
    <span
        className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.8,
        fontWeight: 600,
      }}
    >
      {mexValue}
    </span>
  </span>
        </div>
   
      )}
      {category === "Kids" && (
        <>
        <div style={{ border:"1px solid transparent", position:"absolute", left:2.5, top:"27.4px", width:"93.2%", display:"flex", justifyContent:"center",zIndex:2,alignItems:"center",    transform: "translateY(0.5px)" 
 }}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#7d7d7f",
    fontSize: "7.5px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text
  }}
>
  <span style={{ letterSpacing: "0.35px",
 }}>{filteredIndo[inx]?.name}</span>
  
  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    marginLeft: "2.3px",
    letterSpacing:0.45,
    fontSize: "8.2px",        // Keep consistent base font size

  }}>
    {filteredIndo[inx]?.isMonth}
  </span>

</span>
    
        </div>
        <div style={{ border:"1px solid transparent", position:"absolute", left:2.5, top:"35px", width:"93.2%", display:"flex", justifyContent:"center",zIndex:2,alignItems:"center",    transform: "translateY(0.5px)" 
 }}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#7d7d7f",
    fontSize: "7.5px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text
  }}
>
  <span style={{ letterSpacing: "0.35px",
 }}>{filteredIndo[inx]?.cm?.slice(0, 3)}</span>
  

  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    marginLeft: "2.3px",
    letterSpacing:0.45,
    fontSize: "8.2px",        // Keep consistent base font size

  }}>
    CM
  </span>

</span>
    
        </div>
        </>
      )}
      
      {/* MADE IN Kısmı */}
      <div
  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 2,
    top: "45.7px",
  
  width:"94.7%",
    display: "flex",
    justifyContent: "center",
    flexDirection:"column",

    zIndex:2,
    transform: "translateY(0.5px)"
  }}
>      
<span   className='HelveticaNeueLT57Condensed' style={{ color:"#7d7d7f", fontSize:"7.6px", letterSpacing:0.34, marginTop:.1 }}>

          MADE IN
        </span>
      

      </div>

      <div
  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 2,
    top: "53.7px",
  
  width:"95%",
    display: "flex",
    justifyContent: "center",
    flexDirection:"column",

    zIndex:2,
    transform: "translateY(0.5px)"
  }}
>    

<span   className='HelveticaNeueLT57Condensed' style={{ color:"#7d7d7f", fontSize:"7.6px", letterSpacing:0.34, marginTop:.1 }}>
        {CountryName}
        </span>
    </div>
    </div>
  );
};
const WPZCALL012 = ({currentShape, category, referance, CountryName, filteredIndo, inx, szrgrp, valueBasedOnInx,CardBackBack}) => {
  const [TopValue, setTopValue] = useState("27px")

  // Gelen değerleri konsolda görmek için:
  console.log("USA Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.usa);
  console.log("EUR Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.europe);
  const usaValue = szrgrp?.sizes?.[valueBasedOnInx]?.usa;
  const eurValue =szrgrp?.sizes?.[valueBasedOnInx]?.europe;
  const mexValue =szrgrp?.sizes?.[valueBasedOnInx]?.mexico;
  console.log("refrefgeldi",referance)

  useEffect(() => {
    if (
      referance?.linecount === inx || // linecount, inx'e eşitse
      referance?.linecount === 0 || // linecount 0 ise
      (referance?.linecount !== 0 && inx % referance?.linecount === 0) // linecount 0 değilse ve inx'in katıysa
    ) {
      setTopValue("27.1px");
    } else {
      setTopValue("27px");

    }
  }, [referance, inx]); // 👈 Bağımlılıklar (referance veya inx değiştiğinde çalışır)
  return (
    <div style={{ position:"relative", width:"100%", minHeight:`${referance.height+2.5}mm` }}>
       {CardBackBack ? (
    <div 
      style={{
        position: "absolute", 
        top: `0`, // Her öğe için 5% fark ekleyerek aşağı kaydırıyoruz
    left: "0",

      }}
    >
      {(() => {
        const referenceCode = referance?.code;
        const referenceWidth = referance?.width;
        let width = `${referenceWidth}mm`;
        let height = "auto";

        return typeof CardBackBack === "function" ? (
          <CardBackBack width={width} height={height} />
        ) : (
          <img src={CardBackBack} alt="SVG Image" style={{ width, height }} />
        );
      })()}
    </div>
  ) : (
    <span>Loading...</span>
  )}
      <div style={{ position:"absolute", right:"23px", top:"75.5px" }}>
        {renderShape(currentShape, category,"#7d7d7f")}
      </div>

      {/* Şart: USA ile EUR eşitse bu bloğu döndür */}
      
      {usaValue === eurValue && category !== "Kids" && (
        <>
        <div style={{ border:"1px solid transparent", position:"absolute", left:1.4, top:"24.2px", width:"96%", display:"flex", justifyContent:"center",zIndex:2,alignItems:"center",    transform: "translateY(0.7px)" 
 }}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#7d7d7f",
    fontSize: "7.5px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text
  }}
>
  <span style={{ letterSpacing: "0.25px",
 }}>EUR</span>
  
  <span >/</span>

  <span style={{ letterSpacing: "0.3px", marginRight:0.2,marginLeft:0.35 
 }}>USA</span>

  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    marginLeft: "1.7px",
    letterSpacing:0.35,
    fontSize: "8.2px",        // Keep consistent base font size

  }}>
    {usaValue}
  </span>

</span>
    
        </div>
        <div style={{ border:"1px solid transparent", position:"absolute", left:1.4, top:"32px", width:"96%", display:"flex", justifyContent:"center",zIndex:2,alignItems:"center",    transform: "translateY(0.7px)" 
 }}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#7d7d7f",
    fontSize: "7.5px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text

  }}
>
  <span style={{ letterSpacing: "0.25px",
 }}>MEX</span>
  

  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    marginLeft: "1.9px",
    letterSpacing:0.35,
    fontSize: "8.2px",        // Keep consistent base font size


  }}>
    {mexValue}
  </span>

</span>
    
        </div>
        </>
      )}
      {usaValue !== eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0,top:"18.9px", width:"84.7%", display:"flex", justifyContent:"flex-end",zIndex:2,alignItems:"center"}}>
        <span
               className='HelveticaNeueLT57Condensed'
    style={{
      color: "#7d7d7f",
      fontSize: "7.5px",
      // İsterseniz letterSpacing veya wordSpacing'i buradan da verebilirsiniz
      // letterSpacing: 0.48,
      // wordSpacing: "2px",
    }}
  >
    {/* EUR */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        // marginTop: .1 --> inline-block'ta biraz yukarı boşluk yaratabilir
      }}
    >
      EUR
    </span>

    {/* EUR Value */}
    <span
      className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      {eurValue}
    </span>

    {/* USA */}
    <span
    
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      USA
    </span>

    {/* USA Value (Bold) */}
    <span

    className='HelveticaNeueLT77BoldCondensed'
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        fontWeight: 600,
      }}
    >
      {usaValue}
    </span>

    {/* MEX */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      MEX
    </span>

    {/* MEX Value (Bold, different letterSpacing) */}
    <span
        className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.8,
        fontWeight: 600,
      }}
    >
      {mexValue}
    </span>
  </span>
        </div>
   
      )}
      {category === "Kids" && (
        <>
        <div style={{ border:"1px solid transparent", position:"absolute", left:1.4, top:"24.2px", width:"96%", display:"flex", justifyContent:"center",zIndex:2,alignItems:"center",    transform: "translateY(0.7px)" 
 }}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#7d7d7f",
    fontSize: "7.5px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text
  }}
>
  <span style={{ letterSpacing: "0.25px",
 }}>{filteredIndo[inx]?.name}</span>
  
  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    marginLeft: "2.3px",
    letterSpacing:0.35,
    fontSize: "8.2px",        // Keep consistent base font size

  }}>
    {filteredIndo[inx]?.isMonth}
  </span>

</span>
    
        </div>
        <div style={{ border:"1px solid transparent", position:"absolute", left:1.4, top:"32px", width:"96%", display:"flex", justifyContent:"center",zIndex:2,alignItems:"center",    transform: "translateY(0.7px)" 
 }}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#7d7d7f",
    fontSize: "7.5px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text
  }}
>
  <span style={{ letterSpacing: "0.25px",
 }}>{filteredIndo[inx]?.cm?.slice(0, 3)}</span>
  

  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    marginLeft: "2.3px",
    letterSpacing:0.35,
    fontSize: "8.2px",        // Keep consistent base font size

  }}>
    CM
  </span>

</span>
    
        </div>
        </>
      )}
      
      {/* MADE IN Kısmı */}
      <div
  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 1,
    top: "40.5px",
  
  width:"97.7%",
    display: "flex",
    justifyContent: "center",
    flexDirection:"column",

    zIndex:2,
    transform: "translateY(0.5px)"
  }}
>      
<span   className='HelveticaNeueLT57Condensed' style={{ color:"#7d7d7f", fontSize:"7.6px", letterSpacing:0.25, marginTop:.1,wordSpacing:0 }}>

          MADE IN
        </span>
      

      </div>

      <div
  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 1.3,
    top: "48.3px",
  
  width:"95.7%",
    display: "flex",
    justifyContent: "center",
    flexDirection:"column",

    zIndex:2,
    transform: "translateY(1px)"
  }}
>    

<span   className='HelveticaNeueLT57Condensed' style={{ color:"#7d7d7f", fontSize:"7.6px", letterSpacing:0.25, marginTop:.1 }}>
        {CountryName}
        </span>
    </div>
    </div>
  );
};
const WPZCALL013 = ({currentShape, category, referance, CountryName, filteredIndo, inx, szrgrp, valueBasedOnInx,CardBackBack}) => {
  const [TopValue, setTopValue] = useState("27px")

  // Gelen değerleri konsolda görmek için:
  console.log("USA Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.usa);
  console.log("EUR Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.europe);
  const usaValue = szrgrp?.sizes?.[valueBasedOnInx]?.usa;
  const eurValue =szrgrp?.sizes?.[valueBasedOnInx]?.europe;
  const mexValue =szrgrp?.sizes?.[valueBasedOnInx]?.mexico;
  console.log("refrefgeldi",referance)

  useEffect(() => {
    if (
      referance?.linecount === inx || // linecount, inx'e eşitse
      referance?.linecount === 0 || // linecount 0 ise
      (referance?.linecount !== 0 && inx % referance?.linecount === 0) // linecount 0 değilse ve inx'in katıysa
    ) {
      setTopValue("27.1px");
    } else {
      setTopValue("27px");

    }
  }, [referance, inx]); // 👈 Bağımlılıklar (referance veya inx değiştiğinde çalışır)
  return (
    <div style={{ position:"relative", width:"100%", minHeight:`${referance.height+2.5}mm` }}>
       {CardBackBack ? (
    <div 
      style={{
        position: "absolute", 
        top: `0`, // Her öğe için 5% fark ekleyerek aşağı kaydırıyoruz
    left: "0",

      }}
    >
      {(() => {
        const referenceCode = referance?.code;
        const referenceWidth = referance?.width;
        let width = `${referenceWidth}mm`;
        let height = "auto";

        return typeof CardBackBack === "function" ? (
          <CardBackBack width={width} height={height} />
        ) : (
          <img src={CardBackBack} alt="SVG Image" style={{ width, height }} />
        );
      })()}
    </div>
  ) : (
    <span>Loading...</span>
  )}
      <div style={{ position:"absolute", right:"46.83px", top:"41.5px" }}>
        {renderShape(currentShape, category,"#7c7d7f")}
      </div>

      {/* Şart: USA ile EUR eşitse bu bloğu döndür */}
      
      {usaValue === eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top:"38.2px", width:"75%", display:"flex", justifyContent:"flex-end",zIndex:2,alignItems:"center",    transform: "translateY(0.5px)" 
 }}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#bbbebd",
    fontSize: "8px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text
  }}
>
  <span style={{ letterSpacing:0.4
 }}>EUR</span>
  
  <span style={{ margin: "0 0.4px" ,   
}}>/</span>

  <span style={{ 
     letterSpacing:0.4
 }}>USA</span>

  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    marginLeft: "2.8px",
    fontSize: "8.6px",        // Keep consistent base font size

  }}>
    {usaValue}
  </span>

  <span style={{
    marginLeft: "5px",
    letterSpacing:0.5,
 

  }}>
    MEX
  </span>

  <span 
  
  className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,

    marginLeft: "2.8px",
    fontSize: "8.6px",        // Keep consistent base font size
    letterSpacing:0.35


  }}>
    {mexValue}
  </span>
</span>

        </div>
      )}
      {usaValue !== eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top:"38.2px", width:"75%", display:"flex", justifyContent:"flex-end",zIndex:2,alignItems:"center",    transform: "translateY(0.5px)" 
        }}
>
        <span
               className='HelveticaNeueLT57Condensed'
    style={{
      color: "#bbbebd",
      fontSize: "8px",
      // İsterseniz letterSpacing veya wordSpacing'i buradan da verebilirsiniz
      // letterSpacing: 0.48,
      // wordSpacing: "2px",
    }}
  >
    {/* EUR */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing:0.4
        // marginTop: .1 --> inline-block'ta biraz yukarı boşluk yaratabilir
      }}
    >
      EUR
    </span>

    {/* EUR Value */}
    <span
      className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
      }}
    >
      {eurValue}
    </span>

    {/* USA */}
    <span
    
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing:0.4
      }}
    >
      USA
    </span>

    {/* USA Value (Bold) */}
    <span

    className='HelveticaNeueLT77BoldCondensed'
      style={{
        display: "inline-block",
        marginLeft: 2,
        fontWeight: 600,
      }}
    >
      {usaValue}
    </span>

    {/* MEX */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing:0.4
      }}
    >
      MEX
    </span>

    {/* MEX Value (Bold, different letterSpacing) */}
    <span
        className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        fontWeight: 600,
        letterSpacing:0.4
      }}
    >
      {mexValue}
    </span>
  </span>
        </div>
      )}
      {category === "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top:"38.2px", width:"75%", display:"flex", justifyContent:"flex-end",zIndex:2,alignItems:"center",    transform: "translateY(0.5px)" 
 }}>
        <span
               className='HelveticaNeueLT57Condensed'
  style={{
    color: "#bbbebd",
    fontSize: "8px",
    // Tek bir yerde letterSpacing ya da wordSpacing verebilirsiniz
    // letterSpacing: 0.48,
  }}
>
  {/* filteredIndo[inx]?.name */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      marginTop: 0.1, 
    }}
  >
    {filteredIndo[inx]?.name}
  </span>

  {/* 'MONTH' / 'YEARS' */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      fontWeight: 600,
    }}
  >
    {filteredIndo[inx]?.isMonth}
  </span>

  {/* filteredIndo[inx]?.cm?.slice(0, 3) */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      marginTop: 0.1, 
    }}
  >
    {filteredIndo[inx]?.cm?.slice(0, 3)}
  </span>

  {/* "CM" */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      fontWeight: 600,
    }}
  >
    CM
  </span>
</span>
        </div>
      )}
      
      {/* MADE IN Kısmı */}
      <div
  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 0,
    top:"47.5px", width:"75%",

    display: "flex",
    justifyContent: "flex-end",
    zIndex:2,
    transform: "translateY(0.55px)"
  }}
>        <span   className='HelveticaNeueLT57Condensed' style={{ color:"#bbbebd", fontSize: "8px", marginTop:.1 ,letterSpacing:"0.15px"}}>
          MADE IN {CountryName}
        </span>
      </div>
    </div>
  );
};
const WPZCALL014 = ({currentShape, category, referance, CountryName, filteredIndo, inx, szrgrp, valueBasedOnInx,CardBackBack}) => {
  const [TopValue, setTopValue] = useState("27px")

  // Gelen değerleri konsolda görmek için:
  console.log("USA Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.usa);
  console.log("EUR Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.europe);
  const usaValue = szrgrp?.sizes?.[valueBasedOnInx]?.usa;
  const eurValue =szrgrp?.sizes?.[valueBasedOnInx]?.europe;
  const mexValue =szrgrp?.sizes?.[valueBasedOnInx]?.mexico;
  console.log("refrefgeldi",referance)

  useEffect(() => {
    if (
      referance?.linecount === inx || // linecount, inx'e eşitse
      referance?.linecount === 0 || // linecount 0 ise
      (referance?.linecount !== 0 && inx % referance?.linecount === 0) // linecount 0 değilse ve inx'in katıysa
    ) {
      setTopValue("27.1px");
    } else {
      setTopValue("27px");

    }
  }, [referance, inx]); // 👈 Bağımlılıklar (referance veya inx değiştiğinde çalışır)
  return (
    <div style={{ position:"relative", width:"100%", minHeight:`${referance.height+2.5}mm` }}>
       {CardBackBack ? (
    <div 
      style={{
        position: "absolute", 
        top: `0`, // Her öğe için 5% fark ekleyerek aşağı kaydırıyoruz
    left: "0",

      }}
    >
      {(() => {
        const referenceCode = referance?.code;
        const referenceWidth = referance?.width;
        let width = `${referenceWidth}mm`;
        let height = "auto";

        return typeof CardBackBack === "function" ? (
          <CardBackBack width={width} height={height} />
        ) : (
          <img src={CardBackBack} alt="SVG Image" style={{ width, height }} />
        );
      })()}
    </div>
  ) : (
    <span>Loading...</span>
  )}
      <div style={{ position:"absolute", right:"46.83px", top:"41.5px" }}>
        {renderShape(currentShape, category,"#7d7d7f")}
      </div>

      {/* Şart: USA ile EUR eşitse bu bloğu döndür */}
      
      {usaValue === eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top:"38.2px", width:"75%", display:"flex", justifyContent:"flex-end",zIndex:2,alignItems:"center",    transform: "translateY(0.5px)" 
 }}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#7d7d7f",
    fontSize: "8px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text
  }}
>
  <span style={{ letterSpacing:0.4
 }}>EUR</span>
  
  <span style={{ margin: "0 0.4px" ,   
}}>/</span>

  <span style={{ 
     letterSpacing:0.4
 }}>USA</span>

  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    marginLeft: "2.8px",
    fontSize: "8.6px",        // Keep consistent base font size

  }}>
    {usaValue}
  </span>

  <span style={{
    marginLeft: "5px",
    letterSpacing:0.5,
 

  }}>
    MEX
  </span>

  <span 
  
  className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,

    marginLeft: "2.8px",
    fontSize: "8.6px",        // Keep consistent base font size
    letterSpacing:0.35


  }}>
    {mexValue}
  </span>
</span>

        </div>
      )}
      {usaValue !== eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top:"38.2px", width:"75%", display:"flex", justifyContent:"flex-end",zIndex:2,alignItems:"center",    transform: "translateY(0.5px)" 
        }}
>
        <span
               className='HelveticaNeueLT57Condensed'
    style={{
      color: "#7d7d7f",
      fontSize: "8px",
      // İsterseniz letterSpacing veya wordSpacing'i buradan da verebilirsiniz
      // letterSpacing: 0.48,
      // wordSpacing: "2px",
    }}
  >
    {/* EUR */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing:0.4
        // marginTop: .1 --> inline-block'ta biraz yukarı boşluk yaratabilir
      }}
    >
      EUR
    </span>

    {/* EUR Value */}
    <span
      className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
      }}
    >
      {eurValue}
    </span>

    {/* USA */}
    <span
    
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing:0.4
      }}
    >
      USA
    </span>

    {/* USA Value (Bold) */}
    <span

    className='HelveticaNeueLT77BoldCondensed'
      style={{
        display: "inline-block",
        marginLeft: 2,
        fontWeight: 600,
      }}
    >
      {usaValue}
    </span>

    {/* MEX */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing:0.4
      }}
    >
      MEX
    </span>

    {/* MEX Value (Bold, different letterSpacing) */}
    <span
        className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        fontWeight: 600,
        letterSpacing:0.4
      }}
    >
      {mexValue}
    </span>
  </span>
        </div>
      )}
      {category === "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top:"38.2px", width:"75%", display:"flex", justifyContent:"flex-end",zIndex:2,alignItems:"center",    transform: "translateY(0.5px)" 
 }}>
        <span
               className='HelveticaNeueLT57Condensed'
  style={{
    color: "#7d7d7f",
    fontSize: "8px",
    // Tek bir yerde letterSpacing ya da wordSpacing verebilirsiniz
    // letterSpacing: 0.48,
  }}
>
  {/* filteredIndo[inx]?.name */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      marginTop: 0.1, 
    }}
  >
    {filteredIndo[inx]?.name}
  </span>

  {/* 'MONTH' / 'YEARS' */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      fontWeight: 600,
    }}
  >
    {filteredIndo[inx]?.isMonth}
  </span>

  {/* filteredIndo[inx]?.cm?.slice(0, 3) */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      marginTop: 0.1, 
    }}
  >
    {filteredIndo[inx]?.cm?.slice(0, 3)}
  </span>

  {/* "CM" */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      fontWeight: 600,
    }}
  >
    CM
  </span>
</span>
        </div>
      )}
      
      {/* MADE IN Kısmı */}
      <div
  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 0,
    top:"47.5px", width:"75%",

    display: "flex",
    justifyContent: "flex-end",
    zIndex:2,
    transform: "translateY(0.55px)"
  }}
>        <span   className='HelveticaNeueLT57Condensed' style={{ color:"#7d7d7f", fontSize: "8px", marginTop:.1 ,letterSpacing:"0.15px"}}>
          MADE IN {CountryName}
        </span>
      </div>
    </div>
  );
};
const WPZCALL015 = ({currentShape, category, referance, CountryName, filteredIndo, inx, szrgrp, valueBasedOnInx,CardBackBack}) => {
  const [TopValue, setTopValue] = useState("27px")

  // Gelen değerleri konsolda görmek için:
  console.log("USA Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.usa);
  console.log("EUR Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.europe);
  const usaValue = szrgrp?.sizes?.[valueBasedOnInx]?.usa;
  const eurValue =szrgrp?.sizes?.[valueBasedOnInx]?.europe;
  const mexValue =szrgrp?.sizes?.[valueBasedOnInx]?.mexico;
  console.log("refrefgeldi",referance)

  useEffect(() => {
    if (
      referance?.linecount === inx || // linecount, inx'e eşitse
      referance?.linecount === 0 || // linecount 0 ise
      (referance?.linecount !== 0 && inx % referance?.linecount === 0) // linecount 0 değilse ve inx'in katıysa
    ) {
      setTopValue("27.1px");
    } else {
      setTopValue("27px");

    }
  }, [referance, inx]); // 👈 Bağımlılıklar (referance veya inx değiştiğinde çalışır)
  return (
    <div style={{ position:"relative", width:"100%", minHeight:`${referance.height+2.5}mm` }}>
       {CardBackBack ? (
    <div 
      style={{
        position: "absolute", 
        top: `0`, // Her öğe için 5% fark ekleyerek aşağı kaydırıyoruz
    left: "0",

      }}
    >
      {(() => {
        const referenceCode = referance?.code;
        const referenceWidth = referance?.width;
        let width = `${referenceWidth}mm`;
        let height = "auto";

        return typeof CardBackBack === "function" ? (
          <CardBackBack width={width} height={height} />
        ) : (
          <img src={CardBackBack} alt="SVG Image" style={{ width, height }} />
        );
      })()}
    </div>
  ) : (
    <span>Loading...</span>
  )}
      <div style={{ position:"absolute", right:"28px", top:"31px" }}>
        {renderShape(currentShape, category,"#7c7d7f",3.7)}
      </div>

      {/* Şart: USA ile EUR eşitse bu bloğu döndür */}
      
      {usaValue === eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top:"27.5px", width:"78.9%", display:"flex", justifyContent:"flex-end",zIndex:2,alignItems:"center",    transform: "translateY(0.5px)" 
 }}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#b2b5b4",
    fontSize: "8px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text
   
  }}
>
  <span style={{ letterSpacing: "0.35px",
 }}>EUR</span>
  
  <span style={{ margin: "0 0.4px" ,   
}}>/</span>

  <span style={{ letterSpacing: "0.4px", 
 }}>USA</span>

  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    marginLeft: "2.6px",
    fontSize: "8.5px",        // Keep consistent base font size

  }}>
    {usaValue}
  </span>

  <span style={{
    marginLeft: "5.4px",
    letterSpacing: "0.4px",

  }}>
    MEX
  </span>

  <span 
  
  className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    letterSpacing: "0.8px",
    marginLeft: "2.5px",
    fontSize: "8.5px",        // Keep consistent base font size


  }}>
    {mexValue}
  </span>
</span>

        </div>
      )}
      {usaValue !== eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top:"27.5px", width:"78.9%", display:"flex", justifyContent:"flex-end",zIndex:2,alignItems:"center",    transform: "translateY(0.5px)" 
 }}>        <span
               className='HelveticaNeueLT57Condensed'
    style={{
      color: "#b2b5b4",
      fontSize: "8px",
      // İsterseniz letterSpacing veya wordSpacing'i buradan da verebilirsiniz
      // letterSpacing: 0.48,
      // wordSpacing: "2px",
    }}
  >
    {/* EUR */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        // marginTop: .1 --> inline-block'ta biraz yukarı boşluk yaratabilir
      }}
    >
      EUR
    </span>

    {/* EUR Value */}
    <span
      className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      {eurValue}
    </span>

    {/* USA */}
    <span
    
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      USA
    </span>

    {/* USA Value (Bold) */}
    <span

    className='HelveticaNeueLT77BoldCondensed'
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        fontWeight: 600,
      }}
    >
      {usaValue}
    </span>

    {/* MEX */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      MEX
    </span>

    {/* MEX Value (Bold, different letterSpacing) */}
    <span
        className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.8,
        fontWeight: 600,
      }}
    >
      {mexValue}
    </span>
  </span>
        </div>
      )}
      {category === "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top:"27.5px", width:"78.9%", display:"flex", justifyContent:"flex-end",zIndex:2,alignItems:"center",    transform: "translateY(0.5px)" 
 }}>        <span
               className='HelveticaNeueLT57Condensed'
  style={{
    color: "#b2b5b4",
    fontSize: "8px",
    // Tek bir yerde letterSpacing ya da wordSpacing verebilirsiniz
    // letterSpacing: 0.48,
  }}
>
  {/* filteredIndo[inx]?.name */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      marginTop: 0.1, 
    }}
  >
    {filteredIndo[inx]?.name}
  </span>

  {/* 'MONTH' / 'YEARS' */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    {filteredIndo[inx]?.isMonth}
  </span>

  {/* filteredIndo[inx]?.cm?.slice(0, 3) */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      marginTop: 0.1, 
    }}
  >
    {filteredIndo[inx]?.cm?.slice(0, 3)}
  </span>

  {/* "CM" */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    CM
  </span>
</span>
        </div>
      )}
      
      {/* MADE IN Kısmı */}
      <div
  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 0,
    top: "37px",
  
  width:"78.8%",
    display: "flex",
    justifyContent: "flex-end",
    zIndex:2,
    transform: "translateY(0.3px)"
  }}
>        <span   className='HelveticaNeueLT57Condensed' style={{ color:"#b2b5b4", fontSize:"8px", letterSpacing:0.48, marginTop:.1 }}>
          MADE IN {CountryName}
        </span>
      </div>
    </div>
  );
};

const WPZCALL016 = ({currentShape, category, referance, CountryName, filteredIndo, inx, szrgrp, valueBasedOnInx,CardBackBack}) => {
  const [TopValue, setTopValue] = useState("27px")

  // Gelen değerleri konsolda görmek için:
  console.log("USA Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.usa);
  console.log("EUR Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.europe);
  const usaValue = szrgrp?.sizes?.[valueBasedOnInx]?.usa;
  const eurValue =szrgrp?.sizes?.[valueBasedOnInx]?.europe;
  const mexValue =szrgrp?.sizes?.[valueBasedOnInx]?.mexico;
  console.log("refrefgeldi",referance)

  useEffect(() => {
    if (
      referance?.linecount === inx || // linecount, inx'e eşitse
      referance?.linecount === 0 || // linecount 0 ise
      (referance?.linecount !== 0 && inx % referance?.linecount === 0) // linecount 0 değilse ve inx'in katıysa
    ) {
      setTopValue("27.1px");
    } else {
      setTopValue("27px");

    }
  }, [referance, inx]); // 👈 Bağımlılıklar (referance veya inx değiştiğinde çalışır)
  return (
    <div style={{ position:"relative", width:"100%", minHeight:`${referance.height+2.5}mm` }}>
       {CardBackBack ? (
    <div 
      style={{
        position: "absolute", 
        top: `0`, // Her öğe için 5% fark ekleyerek aşağı kaydırıyoruz
    left: "0",

      }}
    >
      {(() => {
        const referenceCode = referance?.code;
        const referenceWidth = referance?.width;
        let width = `${referenceWidth}mm`;
        let height = "auto";

        return typeof CardBackBack === "function" ? (
          <CardBackBack width={width} height={height} />
        ) : (
          <img src={CardBackBack} alt="SVG Image" style={{ width, height }} />
        );
      })()}
    </div>
  ) : (
    <span>Loading...</span>
  )}
      <div style={{ position:"absolute", right:"28px", top:"31px" }}>
        {renderShape(currentShape, category,"#7b7c7e",3.7)}
      </div>

      {/* Şart: USA ile EUR eşitse bu bloğu döndür */}
      
      {usaValue === eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top:"27.5px", width:"78.9%", display:"flex", justifyContent:"flex-end",zIndex:2,alignItems:"center",    transform: "translateY(0.5px)" 
 }}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#7b7c7e",
    fontSize: "8px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text
   
  }}
>
  <span style={{ letterSpacing: "0.35px",
 }}>EUR</span>
  
  <span style={{ margin: "0 0.4px" ,   
}}>/</span>

  <span style={{ letterSpacing: "0.4px", 
 }}>USA</span>

  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    marginLeft: "2.6px",
    fontSize: "8.5px",        // Keep consistent base font size

  }}>
    {usaValue}
  </span>

  <span style={{
    marginLeft: "5.4px",
    letterSpacing: "0.4px",

  }}>
    MEX
  </span>

  <span 
  
  className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    letterSpacing: "0.8px",
    marginLeft: "2.5px",
    fontSize: "8.5px",        // Keep consistent base font size


  }}>
    {mexValue}
  </span>
</span>

        </div>
      )}
      {usaValue !== eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top:"27.5px", width:"78.9%", display:"flex", justifyContent:"flex-end",zIndex:2,alignItems:"center",    transform: "translateY(0.5px)" 
 }}>        <span
               className='HelveticaNeueLT57Condensed'
    style={{
      color: "#7b7c7e",
      fontSize: "8px",
      // İsterseniz letterSpacing veya wordSpacing'i buradan da verebilirsiniz
      // letterSpacing: 0.48,
      // wordSpacing: "2px",
    }}
  >
    {/* EUR */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        // marginTop: .1 --> inline-block'ta biraz yukarı boşluk yaratabilir
      }}
    >
      EUR
    </span>

    {/* EUR Value */}
    <span
      className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      {eurValue}
    </span>

    {/* USA */}
    <span
    
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      USA
    </span>

    {/* USA Value (Bold) */}
    <span

    className='HelveticaNeueLT77BoldCondensed'
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        fontWeight: 600,
      }}
    >
      {usaValue}
    </span>

    {/* MEX */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      MEX
    </span>

    {/* MEX Value (Bold, different letterSpacing) */}
    <span
        className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.8,
        fontWeight: 600,
      }}
    >
      {mexValue}
    </span>
  </span>
        </div>
      )}
      {category === "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top:"27.5px", width:"78.9%", display:"flex", justifyContent:"flex-end",zIndex:2,alignItems:"center",    transform: "translateY(0.5px)" 
 }}>        <span
               className='HelveticaNeueLT57Condensed'
  style={{
    color: "#7b7c7e",
    fontSize: "8px",
    // Tek bir yerde letterSpacing ya da wordSpacing verebilirsiniz
    // letterSpacing: 0.48,
  }}
>
  {/* filteredIndo[inx]?.name */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      marginTop: 0.1, 
    }}
  >
    {filteredIndo[inx]?.name}
  </span>

  {/* 'MONTH' / 'YEARS' */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    {filteredIndo[inx]?.isMonth}
  </span>

  {/* filteredIndo[inx]?.cm?.slice(0, 3) */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      marginTop: 0.1, 
    }}
  >
    {filteredIndo[inx]?.cm?.slice(0, 3)}
  </span>

  {/* "CM" */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    CM
  </span>
</span>
        </div>
      )}
      
      {/* MADE IN Kısmı */}
      <div
  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 0,
    top: "37px",
  
  width:"78.8%",
    display: "flex",
    justifyContent: "flex-end",
    zIndex:2,
    transform: "translateY(0.3px)"
  }}
>        <span   className='HelveticaNeueLT57Condensed' style={{ color:"#7b7c7e", fontSize:"8px", letterSpacing:0.48, marginTop:.1 }}>
          MADE IN {CountryName}
        </span>
      </div>
    </div>
  );
};

const WPZCALL017 = ({currentShape, category, referance, CountryName, filteredIndo, inx, szrgrp, valueBasedOnInx,CardBackBack}) => {
  const [TopValue, setTopValue] = useState("27px")

  // Gelen değerleri konsolda görmek için:
  console.log("USA Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.usa);
  console.log("EUR Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.europe);
  const usaValue = szrgrp?.sizes?.[valueBasedOnInx]?.usa;
  const eurValue =szrgrp?.sizes?.[valueBasedOnInx]?.europe;
  const mexValue =szrgrp?.sizes?.[valueBasedOnInx]?.mexico;
  console.log("refrefgeldi",referance)

  useEffect(() => {
    if (
      referance?.linecount === inx || // linecount, inx'e eşitse
      referance?.linecount === 0 || // linecount 0 ise
      (referance?.linecount !== 0 && inx % referance?.linecount === 0) // linecount 0 değilse ve inx'in katıysa
    ) {
      setTopValue("27.1px");
    } else {
      setTopValue("27px");

    }
  }, [referance, inx]); // 👈 Bağımlılıklar (referance veya inx değiştiğinde çalışır)
  return (
    <div style={{ position:"relative", width:"100%", minHeight:`${referance.height+2.5}mm` }}>
       {CardBackBack ? (
    <div 
      style={{
        position: "absolute", 
        top: `0`, // Her öğe için 5% fark ekleyerek aşağı kaydırıyoruz
    left: "0",

      }}
    >
      {(() => {
        const referenceCode = referance?.code;
        const referenceWidth = referance?.width;
        let width = `${referenceWidth}mm`;
        let height = "auto";

        return typeof CardBackBack === "function" ? (
          <CardBackBack width={width} height={height} />
        ) : (
          <img src={CardBackBack} alt="SVG Image" style={{ width, height }} />
        );
      })()}
    </div>
  ) : (
    <span>Loading...</span>
  )}
      <div style={{ position:"absolute", right:"28px", top:"31px" }}>
        {renderShape(currentShape, category,"#7c7d7f",3.7)}
      </div>

      {/* Şart: USA ile EUR eşitse bu bloğu döndür */}
      
      {usaValue === eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top:"27.5px", width:"78.9%", display:"flex", justifyContent:"flex-end",zIndex:2,alignItems:"center",    transform: "translateY(0.5px)" 
 }}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#b2b5b4",
    fontSize: "8px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text
   
  }}
>
  <span style={{ letterSpacing: "0.35px",
 }}>EUR</span>
  
  <span style={{ margin: "0 0.4px" ,   
}}>/</span>

  <span style={{ letterSpacing: "0.4px", 
 }}>USA</span>

  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    marginLeft: "2.6px",
    fontSize: "8.5px",        // Keep consistent base font size

  }}>
    {usaValue}
  </span>

  <span style={{
    marginLeft: "5.4px",
    letterSpacing: "0.4px",

  }}>
    MEX
  </span>

  <span 
  
  className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    letterSpacing: "0.8px",
    marginLeft: "2.5px",
    fontSize: "8.5px",        // Keep consistent base font size


  }}>
    {mexValue}
  </span>
</span>

        </div>
      )}
      {usaValue !== eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top:"27.5px", width:"78.9%", display:"flex", justifyContent:"flex-end",zIndex:2,alignItems:"center",    transform: "translateY(0.5px)" 
 }}>        <span
               className='HelveticaNeueLT57Condensed'
    style={{
      color: "#b2b5b4",
      fontSize: "8px",
      // İsterseniz letterSpacing veya wordSpacing'i buradan da verebilirsiniz
      // letterSpacing: 0.48,
      // wordSpacing: "2px",
    }}
  >
    {/* EUR */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        // marginTop: .1 --> inline-block'ta biraz yukarı boşluk yaratabilir
      }}
    >
      EUR
    </span>

    {/* EUR Value */}
    <span
      className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      {eurValue}
    </span>

    {/* USA */}
    <span
    
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      USA
    </span>

    {/* USA Value (Bold) */}
    <span

    className='HelveticaNeueLT77BoldCondensed'
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        fontWeight: 600,
      }}
    >
      {usaValue}
    </span>

    {/* MEX */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      MEX
    </span>

    {/* MEX Value (Bold, different letterSpacing) */}
    <span
        className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.8,
        fontWeight: 600,
      }}
    >
      {mexValue}
    </span>
  </span>
        </div>
      )}
      {category === "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top:"27.5px", width:"78.9%", display:"flex", justifyContent:"flex-end",zIndex:2,alignItems:"center",    transform: "translateY(0.5px)" 
 }}>        <span
               className='HelveticaNeueLT57Condensed'
  style={{
    color: "#b2b5b4",
    fontSize: "8px",
    // Tek bir yerde letterSpacing ya da wordSpacing verebilirsiniz
    // letterSpacing: 0.48,
  }}
>
  {/* filteredIndo[inx]?.name */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      marginTop: 0.1, 
    }}
  >
    {filteredIndo[inx]?.name}
  </span>

  {/* 'MONTH' / 'YEARS' */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    {filteredIndo[inx]?.isMonth}
  </span>

  {/* filteredIndo[inx]?.cm?.slice(0, 3) */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      marginTop: 0.1, 
    }}
  >
    {filteredIndo[inx]?.cm?.slice(0, 3)}
  </span>

  {/* "CM" */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    CM
  </span>
</span>
        </div>
      )}
      
      {/* MADE IN Kısmı */}
      <div
  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 0,
    top: "37px",
  
  width:"78.8%",
    display: "flex",
    justifyContent: "flex-end",
    zIndex:2,
    transform: "translateY(0.3px)"
  }}
>        <span   className='HelveticaNeueLT57Condensed' style={{ color:"#b2b5b4", fontSize:"8px", letterSpacing:0.48, marginTop:.1 }}>
          MADE IN {CountryName}
        </span>
      </div>
    </div>
  );
};

const WPZCALL018 = ({currentShape, category, referance, CountryName, filteredIndo, inx, szrgrp, valueBasedOnInx,CardBackBack}) => {
  const [TopValue, setTopValue] = useState("27px")

  // Gelen değerleri konsolda görmek için:
  console.log("USA Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.usa);
  console.log("EUR Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.europe);
  const usaValue = szrgrp?.sizes?.[valueBasedOnInx]?.usa;
  const eurValue =szrgrp?.sizes?.[valueBasedOnInx]?.europe;
  const mexValue =szrgrp?.sizes?.[valueBasedOnInx]?.mexico;
  console.log("refrefgeldi",referance)

  useEffect(() => {
    if (
      referance?.linecount === inx || // linecount, inx'e eşitse
      referance?.linecount === 0 || // linecount 0 ise
      (referance?.linecount !== 0 && inx % referance?.linecount === 0) // linecount 0 değilse ve inx'in katıysa
    ) {
      setTopValue("27.1px");
    } else {
      setTopValue("27px");

    }
  }, [referance, inx]); // 👈 Bağımlılıklar (referance veya inx değiştiğinde çalışır)
  return (
    <div style={{ position:"relative", width:"100%", minHeight:`${referance.height+2.5}mm` }}>
       {CardBackBack ? (
    <div 
      style={{
        position: "absolute", 
        top: `0`, // Her öğe için 5% fark ekleyerek aşağı kaydırıyoruz
    left: "0",

      }}
    >
      {(() => {
        const referenceCode = referance?.code;
        const referenceWidth = referance?.width;
        let width = `${referenceWidth}mm`;
        let height = "auto";

        return typeof CardBackBack === "function" ? (
          <CardBackBack width={width} height={height} />
        ) : (
          <img src={CardBackBack} alt="SVG Image" style={{ width, height }} />
        );
      })()}
    </div>
  ) : (
    <span>Loading...</span>
  )}
      <div style={{ position:"absolute", right:"28px", top:"31px" }}>
        {renderShape(currentShape, category,"#7b7c7e",3.7)}
      </div>

      {/* Şart: USA ile EUR eşitse bu bloğu döndür */}
      
      {usaValue === eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top:"27.5px", width:"78.9%", display:"flex", justifyContent:"flex-end",zIndex:2,alignItems:"center",    transform: "translateY(0.5px)" 
 }}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#7b7c7e",
    fontSize: "8px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text
   
  }}
>
  <span style={{ letterSpacing: "0.35px",
 }}>EUR</span>
  
  <span style={{ margin: "0 0.4px" ,   
}}>/</span>

  <span style={{ letterSpacing: "0.4px", 
 }}>USA</span>

  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    marginLeft: "2.6px",
    fontSize: "8.5px",        // Keep consistent base font size

  }}>
    {usaValue}
  </span>

  <span style={{
    marginLeft: "5.4px",
    letterSpacing: "0.4px",

  }}>
    MEX
  </span>

  <span 
  
  className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    letterSpacing: "0.8px",
    marginLeft: "2.5px",
    fontSize: "8.5px",        // Keep consistent base font size


  }}>
    {mexValue}
  </span>
</span>

        </div>
      )}
      {usaValue !== eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top:"27.5px", width:"78.9%", display:"flex", justifyContent:"flex-end",zIndex:2,alignItems:"center",    transform: "translateY(0.5px)" 
 }}>        <span
               className='HelveticaNeueLT57Condensed'
    style={{
      color: "#7b7c7e",
      fontSize: "8px",
      // İsterseniz letterSpacing veya wordSpacing'i buradan da verebilirsiniz
      // letterSpacing: 0.48,
      // wordSpacing: "2px",
    }}
  >
    {/* EUR */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        // marginTop: .1 --> inline-block'ta biraz yukarı boşluk yaratabilir
      }}
    >
      EUR
    </span>

    {/* EUR Value */}
    <span
      className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      {eurValue}
    </span>

    {/* USA */}
    <span
    
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      USA
    </span>

    {/* USA Value (Bold) */}
    <span

    className='HelveticaNeueLT77BoldCondensed'
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        fontWeight: 600,
      }}
    >
      {usaValue}
    </span>

    {/* MEX */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      MEX
    </span>

    {/* MEX Value (Bold, different letterSpacing) */}
    <span
        className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.8,
        fontWeight: 600,
      }}
    >
      {mexValue}
    </span>
  </span>
        </div>
      )}
      {category === "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top:"27.5px", width:"78.9%", display:"flex", justifyContent:"flex-end",zIndex:2,alignItems:"center",    transform: "translateY(0.5px)" 
 }}>        <span
               className='HelveticaNeueLT57Condensed'
  style={{
    color: "#7b7c7e",
    fontSize: "8px",
    // Tek bir yerde letterSpacing ya da wordSpacing verebilirsiniz
    // letterSpacing: 0.48,
  }}
>
  {/* filteredIndo[inx]?.name */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      marginTop: 0.1, 
    }}
  >
    {filteredIndo[inx]?.name}
  </span>

  {/* 'MONTH' / 'YEARS' */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    {filteredIndo[inx]?.isMonth}
  </span>

  {/* filteredIndo[inx]?.cm?.slice(0, 3) */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      marginTop: 0.1, 
    }}
  >
    {filteredIndo[inx]?.cm?.slice(0, 3)}
  </span>

  {/* "CM" */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    CM
  </span>
</span>
        </div>
      )}
      
      {/* MADE IN Kısmı */}
      <div
  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 0,
    top: "37px",
  
  width:"78.8%",
    display: "flex",
    justifyContent: "flex-end",
    zIndex:2,
    transform: "translateY(0.3px)"
  }}
>        <span   className='HelveticaNeueLT57Condensed' style={{ color:"#7b7c7e", fontSize:"8px", letterSpacing:0.48, marginTop:.1 }}>
          MADE IN {CountryName}
        </span>
      </div>
    </div>
  );
};
const WPZCALL022 = ({currentShape, category, referance, CountryName, filteredIndo, inx, szrgrp, valueBasedOnInx,CardBackBack}) => {
  const [TopValue, setTopValue] = useState("27px")
  // Gelen değerleri konsolda görmek için:
  console.log("USA Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.usa);
  console.log("EUR Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.europe);
  console.log("SİZEGRRRPPP",filteredIndo[inx])
  console.log("SİZEGRRRPPPALL",szrgrp)
  const usaValue = szrgrp?.sizes?.[valueBasedOnInx]?.usa;
  const eurValue =szrgrp?.sizes?.[valueBasedOnInx]?.europe;
  const mexValue =szrgrp?.sizes?.[valueBasedOnInx]?.mexico;
  console.log("refrefgeldi",referance)

  useEffect(() => {
    if (
      
      referance?.linecount === inx || // linecount, inx'e eşitse
      referance?.linecount === 0 || // linecount 0 ise
      (referance?.linecount !== 0 && inx % referance?.linecount === 0) // linecount 0 değilse ve inx'in katıysa
    ) {

      setTopValue("27.1px");
    } else {
      setTopValue("27px");

    }
  }, [referance, inx]); // 👈 Bağımlılıklar (referance veya inx değiştiğinde çalışır)
  return (
    <div style={{ position:"relative", width:"100%", minHeight:`${referance.height}mm` }}>
       {CardBackBack ? (
    <div 
      style={{
        position: "absolute", 
        top: `0`, // Her öğe için 5% fark ekleyerek aşağı kaydırıyoruz
    left: "0",

      }}
    >
      {(() => {
        const referenceCode = referance?.code;
        const referenceWidth = referance?.width;
        let width = `${referenceWidth}mm`;
        let height = "auto";

        return typeof CardBackBack === "function" ? (
          <CardBackBack width={width} height={height} />
        ) : (
          <img src={CardBackBack} alt="SVG Image" style={{ width, height }} />
        );
      })()}
    </div>
  ) : (
    <span>Loading...</span>
  )}
      <div style={{ position:"absolute", right:"50px", bottom:"80.1px" }}>
      {renderShape(currentShape, category, "#b1b4b3")}
      </div>

      {/* Şart: USA ile EUR eşitse bu bloğu döndür */}
      
      {usaValue === eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:-4, top: "37.9%", width:"98%",marginLeft:4, display:"flex", justifyContent:"center",zIndex:2,    transform: "translateX(0.7px)" 
 }}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#b1b4b3",
    fontSize: "8.4px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text

  }}
>
  <span style={{ letterSpacing: "0.3px",
 }}>EUR</span>
  
  <span style={{ margin: "0 0.4px" ,   
}}>/</span>

  <span style={{ letterSpacing: "0.4px", 
 }}>USA</span>

  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{

    fontWeight: 900,
    marginLeft:"2.2px",
    fontSize: "8.9px",        // Keep consistent base font size

  }}>
    {usaValue}
  </span>

  <span style={{
        marginLeft:"5px",

    letterSpacing: "0.4px",

  }}>
    MEX
  </span>

  <span 
  
  className='HelveticaNeueLT77BoldCondensed'

  style={{
    marginLeft:"2.2px",

    fontWeight: 900,
    letterSpacing: "0.5px",
    fontSize: "8.9px",        // Keep consistent base font size


  }}>
    {mexValue}
  </span>
</span>

        </div>
      )}
      {usaValue !== eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:-4, top: "37.8%", width:"98%",marginLeft:4, display:"flex", justifyContent:"center",zIndex:2,    transform: "translateX(0.7px)" 
 }}
>
  {/* Tek bir ebeveyn span */}
  <span
               className='HelveticaNeueLT57Condensed'
    style={{
      color: "#B1B4B3",
      fontSize: "8.4px",
      // İsterseniz letterSpacing veya wordSpacing'i buradan da verebilirsiniz
      // letterSpacing: 0.48,
      // wordSpacing: "2px",
    }}
  >
    {/* EUR */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        // marginTop: .1 --> inline-block'ta biraz yukarı boşluk yaratabilir
      }}
    >
      EUR
    </span>

    {/* EUR Value */}
    <span
      className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      {eurValue}
    </span>

    {/* USA */}
    <span
    
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      USA
    </span>

    {/* USA Value (Bold) */}
    <span

    className='HelveticaNeueLT77BoldCondensed'
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        fontWeight: 600,
        fontSize: "8.2px",        // Keep consistent base font size

      }}
    >
      {usaValue}
    </span>

    {/* MEX */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      MEX
    </span>

    {/* MEX Value (Bold, different letterSpacing) */}
    <span
        className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.8,
        fontWeight: 600,
        fontSize: "8.4px",        // Keep consistent base font size

      }}
    >
      {mexValue}
    </span>
  </span>
</div>

      )}
      {category === "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:-4, top: "37.8%", width:"98%",marginLeft:4, display:"flex", justifyContent:"center",zIndex:2,    transform: "translateX(0.7px)" 
 }}>
        <span
               className='HelveticaNeueLT57Condensed'
  style={{
    color: "#B1B4B3",
    fontSize: "8.4px",
    // Tek bir yerde letterSpacing ya da wordSpacing verebilirsiniz
    // letterSpacing: 0.48,
  }}
>
  {/* filteredIndo[inx]?.name */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontSize: "8.9px",        // Keep consistent base font size
      fontWeight: 600,

    }}
  >
    {filteredIndo[inx]?.name}
  </span>

  {/* 'MONTH' / 'YEARS' */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 300,
    }}
  >
  {filteredIndo[inx]?.isMonth}
  </span>

  {/* filteredIndo[inx]?.cm?.slice(0, 3) */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontSize: "8.9px",        // Keep consistent base font size
      fontWeight: 600,
    }}
  >
    {filteredIndo[inx]?.cm?.slice(0, 3)}
  </span>

  {/* "CM" */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 300,
    }}
  >
    CM
  </span>
</span>

        </div>
      )}
      
      {/* MADE IN Kısmı */}
      <div

  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: -4.2,
    marginLeft:4.4,
    top: "109px",
    width:"98.4%",
    display: "flex",
    justifyContent: "center",
    zIndex:2,
    transform: "translateY(1.2px)" 

  }}
>        <span  className='HelveticaNeueLT57Condensed' style={{ color:"#b1b4b3", fontSize:"8.2px", letterSpacing:0.45 }}>
          MADE IN {CountryName}
        </span>
      </div>
    </div>
  );
};
const WPZCALL023 = ({currentShape, category, referance, CountryName, filteredIndo, inx, szrgrp, valueBasedOnInx,CardBackBack}) => {
  const [TopValue, setTopValue] = useState("27px")

  // Gelen değerleri konsolda görmek için:
  console.log("USA Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.usa);
  console.log("EUR Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.europe);
  const usaValue = szrgrp?.sizes?.[valueBasedOnInx]?.usa;
  const eurValue =szrgrp?.sizes?.[valueBasedOnInx]?.europe;
  const mexValue =szrgrp?.sizes?.[valueBasedOnInx]?.mexico;
  console.log("refrefgeldi",referance)

  useEffect(() => {
    if (
      referance?.linecount === inx || // linecount, inx'e eşitse
      referance?.linecount === 0 || // linecount 0 ise
      (referance?.linecount !== 0 && inx % referance?.linecount === 0) // linecount 0 değilse ve inx'in katıysa
    ) {
      setTopValue("27.1px");
    } else {
      setTopValue("27px");

    }
  }, [referance, inx]); // 👈 Bağımlılıklar (referance veya inx değiştiğinde çalışır)
  return (
    <div style={{ position:"relative", width:"100%", minHeight:`${referance.height}mm` }}>
       {CardBackBack ? (
    <div 
      style={{
        position: "absolute", 
        top: `0`, // Her öğe için 5% fark ekleyerek aşağı kaydırıyoruz
    left: "0",

      }}
    >
      {(() => {
        const referenceCode = referance?.code;
        const referenceWidth = referance?.width;
        let width = `${referenceWidth}mm`;
        let height = "auto";

        return typeof CardBackBack === "function" ? (
          <CardBackBack width={width} height={height} />
        ) : (
          <img src={CardBackBack} alt="SVG Image" style={{ width, height }} />
        );
      })()}
    </div>
  ) : (
    <span>Loading...</span>
  )}
      <div style={{ position:"absolute", right:"50px", bottom:"80.1px" }}>
      {renderShape(currentShape, category, "#727173")}
      </div>

      {/* Şart: USA ile EUR eşitse bu bloğu döndür */}
      
      {usaValue === eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:-4, top: "37.9%", width:"98%",marginLeft:4, display:"flex", justifyContent:"center",zIndex:2,    transform: "translateX(0.7px)" 
 }}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#727173",
    fontSize: "8.4px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text

  }}
>
  <span style={{ letterSpacing: "0.3px",
 }}>EUR</span>
  
  <span style={{ margin: "0 0.4px" ,   
}}>/</span>

  <span style={{ letterSpacing: "0.4px", 
 }}>USA</span>

  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{

    fontWeight: 900,
    marginLeft:"2.2px",
    fontSize: "8.9px",        // Keep consistent base font size

  }}>
    {usaValue}
  </span>

  <span style={{
        marginLeft:"5px",

    letterSpacing: "0.4px",

  }}>
    MEX
  </span>

  <span 
  
  className='HelveticaNeueLT77BoldCondensed'

  style={{
    marginLeft:"2.2px",

    fontWeight: 900,
    letterSpacing: "0.5px",
    fontSize: "8.9px",        // Keep consistent base font size


  }}>
    {mexValue}
  </span>
</span>

        </div>
      )}
      {usaValue !== eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:-4, top: "37.8%", width:"98%",marginLeft:4, display:"flex", justifyContent:"center",zIndex:2,    transform: "translateX(0.7px)" 
 }}
>
  {/* Tek bir ebeveyn span */}
  <span
               className='HelveticaNeueLT57Condensed'
    style={{
      color: "#727173",
      fontSize: "8.4px",
      // İsterseniz letterSpacing veya wordSpacing'i buradan da verebilirsiniz
      // letterSpacing: 0.48,
      // wordSpacing: "2px",
    }}
  >
    {/* EUR */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        // marginTop: .1 --> inline-block'ta biraz yukarı boşluk yaratabilir
      }}
    >
      EUR
    </span>

    {/* EUR Value */}
    <span
      className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      {eurValue}
    </span>

    {/* USA */}
    <span
    
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      USA
    </span>

    {/* USA Value (Bold) */}
    <span

    className='HelveticaNeueLT77BoldCondensed'
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        fontWeight: 600,
        fontSize: "8.2px",        // Keep consistent base font size

      }}
    >
      {usaValue}
    </span>

    {/* MEX */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      MEX
    </span>

    {/* MEX Value (Bold, different letterSpacing) */}
    <span
        className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.8,
        fontWeight: 600,
        fontSize: "8.4px",        // Keep consistent base font size

      }}
    >
      {mexValue}
    </span>
  </span>
</div>

      )}
      {category === "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:-4, top: "37.8%", width:"98%",marginLeft:4, display:"flex", justifyContent:"center",zIndex:2,    transform: "translateX(0.7px)" 
 }}>
        <span
               className='HelveticaNeueLT57Condensed'
  style={{
    color: "#727173",
    fontSize: "8.4px",
    // Tek bir yerde letterSpacing ya da wordSpacing verebilirsiniz
    // letterSpacing: 0.48,
  }}
>
  {/* filteredIndo[inx]?.name */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontSize: "8.9px",        // Keep consistent base font size

    }}
  >
    {filteredIndo[inx]?.name}
  </span>

  {/* 'MONTH' / 'YEARS' */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    {filteredIndo[inx]?.isMonth}
  </span>

  {/* filteredIndo[inx]?.cm?.slice(0, 3) */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontSize: "8.9px",        // Keep consistent base font size

    }}
  >
    {filteredIndo[inx]?.cm?.slice(0, 3)}
  </span>

  {/* "CM" */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    CM
  </span>
</span>

        </div>
      )}
      
      {/* MADE IN Kısmı */}
      <div

  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: -4.2,
    marginLeft:4.4,
    top: "109px",
    width:"98.4%",
    display: "flex",
    justifyContent: "center",
    zIndex:2,
    transform: "translateY(1.2px)" 

  }}
>        <span  className='HelveticaNeueLT57Condensed' style={{ color:"#727173", fontSize:"8.2px", letterSpacing:0.45 }}>
          MADE IN {CountryName}
        </span>
      </div>
    </div>
  );
};


// Bileşenleri bir obje içinde saklıyoruz
const components = {
  LABEL7HOMEWEAR70x10,
  LABEL7DELTAWSIZE110x15,
  WLZCALL030,
  WLZCALL031,
  WLZCALL035,
  WLZCALL036,
  WPZCALL001,
  WPZCALL002,
  WPZCALL003,
  WPZCALL004,
  WPZCALL005,
  WPZCALL006,
  WPZCALL007,
  WPZCALL008,
  WPZCALL009,
  WPZCALL010,
  WPZCALL011,
  WPZCALL012,
  WPZCALL013,
  WPZCALL014,
  WPZCALL015,
  WPZCALL016,
  WPZCALL017,
  WPZCALL018,
  WPZCALL022,
  WPZCALL023
  
};

// Gelen referansa göre bileşeni seçiyoruz
const Page1 = ({ selectColor,barcodeValue,data,harmacn,referance,SouthAmerica,sizeData,indo,szrgrp,inx,CardBackBack }) => {
  const [currentShape, setCurrentShape] = useState(null)

  const cleanCode = referance?.code?.replace(/\s+/g, '');
  const Component = components[cleanCode];

  const department = data.department
  const [brand, category, subCategory] = department.split(' / ')
  const filteredIndo = indo.filter((item) => item.amount !== '')

  const indexedIndo = indo.reduce((acc, item, index) => {
    if (item.amount !== '') {
      acc.push(index)
    }
    return acc
  }, [])
  const valueBasedOnInx = indexedIndo[inx]

  useEffect(() => {
    if (subCategory) {
      setCurrentShape(subCategory)
    }
  }, [subCategory])

  return (
    <Component 
      currentShape={currentShape}  
      category={category} 
      referance={referance} 
      CountryName={data?.country?.name} // ✅ Hata düzeltildi
      filteredIndo={filteredIndo}
      inx={inx}
      szrgrp={szrgrp}
      valueBasedOnInx={valueBasedOnInx}
      CardBackBack={CardBackBack}
    />
  );};

export default Page1;
